
const translations = {
    "Notice!": "Advarsel!",
    "Are you sure that you want to delete this?": "Er du sikker på, at du vil slette dette?",
    "Confirm": "Bekræft",
    "Cancel": "Fortryd",
    "Min": "Minimum",
    "Max": "Max",
    "Before": "Før",
    "After": "Efter",
    "w": "u",
    "week": "uge",
    "weeks": "uger",
    "d": "d",
    "day": "dag",
    "days": "dage",
    "Due date": "Afleveringsfrist",
    "Start date": "Start dato",
    "Internal date": "Intern dato",
    "Notes": "Bemærkninger",
    "Document": "Dokument",
    "Email": "Email",
    "Billing": "Fakturering",
    "Add": "Tilføj",
    "Archived": "Arkiveret",
    "Cancelled": "Annulleret",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "Client company": "Kundevirksomhed",
    "General info": "Generel info",
    "Digitisation of client documents": "Digitalisering af klientdokumenter",
    "Client portal": "Klientportal",
    "Documents": "Dokumenter",
    "Members": "Medlemmer",
    "Preferences": "Præferencer",
    "Yes": "Ja",
    "No": "Ingen",
    "Total hours": "Samlet antal timer",
    "Extra hours": "Ekstra timer",
    "Client": "Klient",
    "Tasks": "Opgaver",
    "Disable Uku’s task templates": "Deaktiver Uku's opgaveskabeloner",
    "Set the estimation as time when the exact value is not entered": "Indstil estimeringen som det tidspunkt, hvor den nøjagtige værdi ikke indtastes",
    "Checklist must be completed to finish the task": "Tjeklisten skal udfyldes for at afslutte opgaven",
    "Disable topic management for members": "Deaktivere emneadministration for medlemmer",
    "Disable time edit for members": "Deaktivere tidsredigering for medlemmer",
    "Allow time entries in future": "Tillad tidsangivelser i fremtiden",
    "Show all dependent tasks in the calendar": "Vis alle afhængige opgaver i kalenderen",
    "Clients": "Kunder",
    "Disable adding new clients for members": "Deaktiver tilføjelse af nye klienter for medlemmer",
    "Only administrators can edit documents": "Kun administratorer kan redigere dokumenter",
    "Allow digitisation of client documents": "Tillad digitalisering af klientdokumenter",
    "Use my Microsoft account": "Brug min Microsoft-konto",
    "Disconnect my Microsoft account": "Afbryd forbindelsen til min Microsoft-konto",
    "Connect my Microsoft account": "Tilslut min Microsoft-konto",
    "Use my google account": "Brug min Google-konto",
    "Connect my google account": "Tilslut min Google-konto",
    "Disconnect my google account": "Afbryd forbindelsen til min Google-konto",
    "Emails": "E-mails",
    "Daily agenda": "Daglig dagsorden",
    "Unread notifications": "Ulæste meddelelser",
    "Task assigned to me": "Opgave tildelt mig",
    "Weekly summary": "Ugentligt resumé",
    "Monthly summary": "Månedligt resume",
    "Updates and tips": "Opdateringer og tip",
    "Overdue": "Forsinket",
    "1 day": "1 dag",
    "1 day overdue": "1 dag forsinket",
    "{0} days": "{0} dage",
    "{0} days overdue": "{0} dage for sent",
    "{0} minute ago": "{0} minut siden",
    "{0} minutes ago": "{0} minutter siden",
    "{0} hour ago": "{0} time siden",
    "{0} hours ago": "{0} timer siden",
    "Sunday": "Søndag",
    "Monday": "Mandag",
    "Tuesday": "Tirsdag",
    "Wednesday": "Onsdag",
    "Thursday": "Torsdag",
    "Friday": "Fredag",
    "Saturday": "Lørdag",
    "Sun": "Søn",
    "Mon": "Man",
    "Tue": "Tirs",
    "Wed": "Ons",
    "Thu": "Tor",
    "Fri": "Fre",
    "Sat": "Lør",
    "January": "Januar",
    "February": "Februar",
    "March": "Marts",
    "April": "April",
    "May": "Maj",
    "June": "Juni",
    "July": "Juli",
    "August": "August",
    "September": "September",
    "October": "Oktober",
    "November": "November",
    "December": "December",
    "Jan": "Jan",
    "Feb": "Feb",
    "Mar": "Mar",
    "Apr": "Apr",
    "Jun": "Jun",
    "Jul": "Jul",
    "Aug": "Aug",
    "Sep": "Sep",
    "Oct": "Okt",
    "Nov": "Nov",
    "Dec": "Dec",
    "Today": "I dag",
    "Yesterday": "I går",
    "Day": "Dag",
    "Days": "Dage",
    "+{0} d": "+{0} d",
    "+{0} wd": "+{0} wd",
    "Weekly {0}": "Ugentlig {0}",
    "Every {0}. week {1}": "Hver {0}. uge {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Månedlig {0}. d",
    "Every {0}. month {1}. d": "Hver {0}. måned {1}. d",
    "{0}. d": "{0}. d",
    "Quarterly {0}. month {1}. d": "Kvartalsvis {0}. måned {1}. d",
    "Every {0}. quarter {1}. month {2}. d": "Hver {0}. kvartal {1}. måned {2}. d",
    "{0}. month {1}. d": "{0}. måned {1}. d",
    "Yearly {0}": "Årligt {0}",
    "Every {0}. year {1}": "Hver {0}. år {1}",
    "Mo": "Ma",
    "Tu": "Tirs",
    "We": "On",
    "Th": "To",
    "Fr": "Fr",
    "Sa": "Lør",
    "Su": "Søn",
    "and": "og",
    "{0}w": "{0}u",
    "{0}d": "{0}d",
    "before": "før",
    "after": "efter",
    "Project": "Projekt",
    "Quarter": "Kvarter",
    "Add your photo": "Tilføj dit foto",
    "Adding file failed": "Tilføjelse af fil mislykkedes",
    "Please check the file.": "Kontroller filen.",
    "You can only add pictures.": "Du kan kun tilføje billeder.",
    "Error": "Fejl",
    "Create new topic": "Opret nyt emne",
    "Name": "Navn",
    "Close": "Luk",
    "Find topic...": "Find emne...",
    "New topic": "Nyt emne",
    "Invalid format": "Ugyldigt format",
    "Demo company account": "Demo firmakonto",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demokontoen slettets senere. Benyt kun til testformål!",
    "Subscribe": "Abonner",
    "Start demo": "Start demo",
    "End demo": "Afslut demo",
    "Free trial is expired - {0}": "Gratis prøveperiode er udløbet - {0}",
    "Free trial {1} {2} left - {0}": "Gratis prøveperiode {1} {2} tilbage - {0}",
    "Add time": "Tilføj tid",
    "Billable": "Fakturerbar",
    "Date": "Dato",
    "Start": "Start",
    "End": "Slut",
    "Duration": "Varighed",
    "Split duration equally": "Del varigheden ligeligt",
    "Required field": "Påkrævet felt",
    "Members list": "Liste over medlemmer",
    "Edit fields": "Rediger felter",
    "Maximum number of selected columns has been exceeded": "Det maksimale antal valgte kolonner er overskredet",
    "If you want to add a new column to the report, please remove an existing one first.": "Hvis du vil føje en ny kolonne til rapporten, skal du først fjerne en eksisterende kolonne.",
    "Snooze until...": "Udsæt indtil...",
    "Select date & time": "Vælg dato og klokkeslæt",
    "Tomorrow": "I morgen",
    "Later this week": "Senere denne uge",
    "Next week": "Næste uge",
    "Add task": "Tilføj opgave",
    "Checklist": "Tjekliste",
    "Start timer": "Start timer",
    "Add an item": "Tilføj et element",
    "Add checklist item": "Tilføj tjeklisteelement",
    "Convert to a task": "Konverter til en opgave",
    "Delete": "Slet",
    "Delegate to...": "Delegere til...",
    "Please select tasks from the same account": "Valgte opgaver skal være fra den samme konto",
    "Follow": "Følg",
    "Expand sidebar": "Udvid sidepanelet",
    "Nicely done!": "Godt gjort!",
    "You've finished all your tasks, take a second to recharge": "Du er færdig med alle dine opgaver, brug et øjeblik på at genoplade dine batterier",
    "Search tasks...": "Søg opgaver...",
    "Search": "Søg",
    "select/unselect all": "vælg/fravælg alle",
    "Add new client": "Tilføj ny klient",
    "Account": "Konto",
    "Client name": "Kundenavn",
    "Select client": "Vælg klient",
    "New client": "Ny kunde",
    "Must be an integer": "Skal være et heltal",
    "Must be a number": "Skal være et tal",
    "Dashboard": "Dashboard",
    "Calendar": "Kalender",
    "Report": "Rapport",
    "Monitoring": "Overvågning",
    "Suppliers": "Leverandører",
    "Events": "Begivenheder",
    "Projects": "Projekter",
    "Help": "Hjælp",
    "Settings & Apps": "Indstillinger",
    "Profile": "Profil",
    "Collapse menu": "Skjul menuen",
    "Expand menu": "Udvid menuen",
    "Are you sure to delete this attachment?": "Er du sikker på at slette denne vedhæftede fil?",
    "Select": "Vælg",
    "Edit contacts": "Rediger kontakter",
    "Add member": "Tilføj medlem",
    "Add note": "Tilføj note",
    "Open": "Åben",
    "Reports": "Rapporter",
    "Billing notes": "Noter til fakturering",
    "Pinned notes": "Fastgjorte noter",
    "Sub-companies": "Undervirksomheder",
    "Contacts": "Kontakter",
    "Event info": "Info om begivenheden",
    "Project info": "Information om projektet",
    "Summary": "Resumé",
    "Task": "Opgave",
    "Time": "Tid",
    "Collapse sidebar": "Skjul sidebjælken",
    "Client Overview": "Oversigt over klienter",
    "Event Overview": "Overblik over arrangement",
    "Project Overview": "Projektoversigt",
    "Edit client": "Rediger klient",
    "Edit event": "Rediger begivenhed",
    "Edit project": "Rediger projekt",
    "Show all": "Vis alt",
    "Collapse": "Fold sammen",
    "by": "af",
    "View all": "Se alt",
    "Add company event": "Tilføj virksomhedsbegivenhed",
    "Company": "Virksomhed",
    "Info": "Info",
    "Holiday": "Ferie",
    "All day(s)": "Alle dage",
    "End date": "Slutdato",
    "From": "Fra",
    "Until": "Indtil",
    "Hours": "Timer",
    "Link": "Link",
    "Save": "Gem",
    "Are you sure that you want to delete this company calendar event?": "Er du sikker på, at du vil slette denne firmakalenderbegivenhed?",
    "Location of client folder in your document management system": "Placering af klientmappe i dit dokumenthåndteringssystem",
    "Defined main folder": "Defineret hovedmappe",
    "Custom folder": "Brugerdefineret mappe",
    "Add new role": "Tilføj ny rolle",
    "New role": "Ny rolle",
    "Access enabled": "Adgang aktiveret",
    "Waiting for files": "Venter på filer",
    "Uploaded": "Uploadet",
    "Uploading...": "Uploader...",
    "Client members": "Klientmedlemmer",
    "Email settings": "E-mailindstillinger",
    "Or connect new email address": "Eller tilslut en ny e-mail-adresse",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Forbind med Microsoft Exchange eller en anden e-mail-server (SMTP)",
    "Test email sent": "Test e-mail sendt",
    "Email address": "E-mail addresse",
    "Reply address": "Svaradresse",
    "Sender name": "Afsenderens navn",
    "Who can use?": "Hvem kan bruge?",
    "Client default address": "Klientens standardadresse",
    "Invalid e-mail": "Ugyldig email",
    "Role": "Rolle",
    "E-mail": "E-mail",
    "Mobile phone": "Mobiltelefon",
    "Work phone": "Arbejdstelefon",
    "Language": "Sprog",
    "Birthday": "Fødselsdag",
    "Are you sure to delete this contact?": "Er du sikker på, at du vil slette denne kontakt?",
    "Manage contact fields": "Administrer kontaktfelter",
    "Administrative Assistant": "Administrativ Assistent",
    "Board member": "Bestyrelsesmedlem",
    "CEO": "Direktør",
    "Add contact": "Tilføj kontakt",
    "Contact person": "Kontaktperson",
    "Leave page?": "Forlad siden?",
    "Changes that you made may not be saved": "Ændringer, som du har foretaget, bliver muligvis ikke gemt",
    "Leave": "Forlad",
    "Super! We're importing your clients...": "Super! Vi importerer dine kunder...",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Du er velkommen til at forlade denne side. Der vises en meddelelse, når importen er forberedt. Derefter skal du bekræfte de kunder, du ønsker at tilføje til Uku.",
    "Please wait...": "Vent venligst...",
    "Setup API keys": "Opsætning af API-nøgler",
    "You have two options": "Du har to muligheder",
    "how to setup API keys": "hvordan man opsætter API-nøgler",
    "Continue": "Fortsæt",
    "Custom import": "Brugerdefineret importering",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "For at importere kunder og arbejdsvolumen fra !INTEGRATION har Uku brug for !INTEGRATION API-nøgle for hver enkelt kunde.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Fortsæt</span> - Uku opretter automatisk API-nøgler for hver klient",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "1. <span class=font-weight-medium>Brugerdefineret import</span> - Uku opretter kun forbindelse med eksisterende UKU API-nøgler. Opret API-nøgler manuelt i !INTEGRATION før import. Læs:",
    "(it takes a lot of time)": "(det tager meget lang tid)",
    "Import Clients": "Tilføj og opdater data",
    "Country": "Land",
    "Please choose your country": "Vælg venligst dit land",
    "Password": "Adgangskode",
    "Start import": "Start importering",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Indsæt !INTEGRATION loginoplysninger (det er sikkert) for at give adgang til importklienter og API-nøgler denne ene gang. Bemærk venligst, at du vil blive logget ud af !INTEGRATION i andre browsere.",
    "Update invoice status": "Opdater fakturaens status",
    "Update now": "Opdater nu",
    "Daily @ 14:00": "Dagligt kl. 14:00",
    "Daily @ 18:00": "Dagligt kl. 18:00",
    "Updating invoice statuses, please wait...": "Opdaterer fakturastatus, vent venligst...",
    "Your import is ready": "Din importering er klar",
    "In the final step you need to confirm the clients you want to add to uku": "I det sidste trin skal du bekræfte de kunder, du ønsker at tilføje til uku",
    "Let's go": "Begynd",
    "Import again": "Importer igen",
    "Do you have new clients to import?": "Har du nye kunder, der skal importeres?",
    "Yes, i do": "Ja, det har jeg",
    "View last import": "Se sidste import",
    "Email server": "E-mail server",
    "Email provider": "E-mail-udbyder",
    "Host": "Host",
    "Port": "Port",
    "Security": "Sikkerhed",
    "Sender email": "Afsenderens e-mail",
    "Username": "Brugernavn",
    "Test connection": "Test forbindelse",
    "How to set up": "Sådan opsættes",
    "Only administrators can activate the app": "Kun administratorer kan aktivere appen",
    "You are in the waiting list": "Du er på venteliste",
    "We onboard all applicants one by one": "Marker din interesse, og vi giver besked, når appen er tilgængelig til test",
    "Connected": "Forbundet",
    "Activated": "Aktiveret",
    "Join waiting list": "Kom på venteliste",
    "Activate": "Aktiver",
    "Unsubscribe from waiting list": "Afmeld venteliste",
    "Deactivate app": "Deaktiver appen",
    "Disconnect": "Afbryd",
    "Hide expanded content": "Skjul udvidet indhold",
    "Show trimmed content": "Vis trimmet indhold",
    "Email not delivered": "E-mail ikke leveret",
    "Sent, but fallback to Uku email": "Sendt, men tilbagefald til Uku-mail",
    "Unknown error": "Ukendt fejl",
    "to": "til",
    "in any minute": "når som helst",
    "on {0},": "på {0},",
    "or": "eller",
    "Send now": "Send nu",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku <span class='subtitle-2'>sender</span> email",
    "__From_email": "__From_email",
    "Set up email": "Opsætning af e-mail",
    "Client default": "Klient standard",
    "Subject": "Emne",
    "Edit email": "Rediger e-mail",
    "Template": "Skabelon",
    "Cc": "Cc",
    "Bcc": "Bcc",
    "__To_email": "__To_email",
    "__Cc_email": "__Cc_email",
    "__Bcc_email": "__Bcc_email",
    "Add template": "Tilføj skabelon",
    "Add automation": "Tilføj automatisering",
    "Add placeholder": "Tilføj pladsholder",
    "Format text": "Formater tekst",
    "Add attachment": "Tilføj vedhæftet fil",
    "Send": "Send",
    "Save automation": "Gem automatisering",
    "Choose email template": "Vælg e-mail-skabelon",
    "All languages": "Alle sprog",
    "No templates found.": "Ingen skabeloner fundet.",
    "Edit email template": "Rediger e-mail-skabelon",
    "Are you sure you want to delete this template? Some tasks will be affected": "Er du sikker på, at du vil slette denne skabelon? Nogle opgaver kan blive påvirket",
    "Are you sure you want to delete this template?": "Er du sikker på, at du vil slette denne skabelon?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Er du sikker på, at du ønsker at gemme denne skabelon? Følgende opgaver vil blive påvirket:",
    "Template name": "Skabelonens navn",
    "Edit template": "Rediger skabelon",
    "Send email": "Send email",
    "on": "på",
    "Ok": "OK",
    "Supplier": "Leverandør",
    "Event": "Begivenhed",
    "Contact": "Kontakt",
    "Validation failed": "Validering mislykkedes",
    "Saving supplier failed": "Gemning af leverandør mislykkedes",
    "Saving client failed": "Gemning af klient mislykkedes",
    "Saving project failed": "Gemning af projekt mislykkedes",
    "several values": "flere værdier",
    "values": "værdier",
    "is": "er",
    "Add filter": "Tilføj filter",
    "Update": "Opdatering",
    "forever": "for evigt",
    "Last week": "Sidste uge",
    "This week": "Denne uge",
    "Last month": "Sidste måned",
    "This month": "Denne måned",
    "Next month": "Næste måned",
    "Last year": "Sidste år",
    "This year": "Dette år",
    "This quarter": "Dette kvartal",
    "Next quarter": "Næste kvartal",
    "Last quarter": "Sidste kvartal",
    "Client group": "Kundegruppe",
    "Topic": "Emne",
    "Member": "Medlem",
    "Primary member": "Primære medlem",
    "Client status": "Klientstatus",
    "Active clients": "Aktive klienter",
    "Inactive clients": "Inaktive kunder",
    "All": "Alle",
    "Project status": "Projekt status",
    "Member status": "Medlemsstatus",
    "Active members": "Aktive medlemmer",
    "Limited members": "Begrænsede medlemmer",
    "Inactive members": "Inaktive medlemmer",
    "Contract status": "Kontrakt status",
    "Active contracts": "Aktive kontrakter",
    "Pending contracts": "Igangværende kontrakter",
    "Finished contracts": "Afsluttede kontrakter",
    "Contract template": "Skabelon til kontrakt",
    "Payment recurrence": "Gentagelse af betaling",
    "Yearly": "Årligt",
    "Monthly": "Månedlig",
    "Trial": "Forsøg",
    "Region": "Område",
    "Field": "Felt",
    "All tasks": "Alle opgaver",
    "Todo": "At gøre",
    "Not done": "Ikke færdig",
    "Done": "Færdig",
    "Delayed": "Forsinket",
    "Important": "Vigtig",
    "Extra work": "Ekstra arbejde",
    "I Follow": "Jeg følger",
    "Commented": "Kommenterede",
    "Tracked time": "Sporet tid",
    "Estimated": "Anslået",
    "Recurring task": "Tilbagevendende opgave",
    "Last import": "Sidste importering",
    "Period": "Periode",
    "Client search": "Kundesøgning",
    "Voucher": "Rabatkupon",
    "Company status": "Firmastatus",
    "Deleted": "Slettet",
    "All status": "Alle status",
    "Payment gateway": "Betalings gateway",
    "All gateways": "Alle gateways",
    "Uku manually": "Uku manuelt",
    "Braintree": "Braintree",
    "Plan status": "Planens status",
    "All plans": "Alle planer",
    "Paid": "Betalt",
    "Paid churn": "Betalt churn",
    "Trial churn": "Forsøgsafbrydelse",
    "Plan period": "Planperiode",
    "All periods": "Alle perioder",
    "Monthly plan": "Månedlig plan",
    "Yearly plan": "Årlig plan",
    "Company search": "Virksomhedssøgning",
    "User search": "Brugersøgning",
    "Name key search": "Navn nøglesøgning",
    "None filter": "Ingen filter",
    "OK": "OK",
    "Start date cannot be later than due date": "Startdato kan ikke være senere end forfaldsdato",
    "tasks": "opgaver",
    "task(s) had errors": "opgave(r) havde fejl",
    "tasks selected": "valgte opgaver",
    "Postpone": "Udsæt",
    "Mark done": "Markering færdig",
    "Hide multiselect": "Skjul multiselect",
    "Delete task(s)": "Slet opgave(r)",
    "All of the data related to the task will be deleted": "Alle de data, der er relateret til opgaven, slettes",
    "Some tasks include other people. Are you sure you want to delete?": "Nogle opgaver omfatter andre mennesker. Er du sikker på, at du vil slette?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Der er registreret tid på nogle af de valgte aktiviteter. Er du sikker på, at du vil slette?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Der er registreret tid for nogle af de udvalgte aktiviteter. Nogle opgaver omfatter andre personer. Er du sikker på, at du vil slette?",
    "task(s) were not marked done": "opgave (r) blev ikke markeret som udført",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Kontroller venligst, om tjeklisten er udfyldt, eller om tiden er angivet, og er tildelt dig",
    "task(s) were not deleted": "opgave(r) blev ikke slettet",
    "task(s) time was not updated": "opgave(r) tid blev ikke opdateret",
    "Please make sure that you can add time to task": "Sørg for, at du kan tilføje tid til opgaven",
    "invoice table row": "faktura tabel række",
    "invoice table row(s) had errors": "der var fejl i en eller flere rækker i fakturatabellen",
    "invoice table row(s) selected": "række(r) i fakturatabellen valgt",
    "Create": "Opret",
    "Mark paid": "Marker som betalt",
    "Send to client": "Send til kunden",
    "Recalculate": "Genberegn",
    "Export to {0}": "Eksporter til {0}",
    "Update Status from {0}": "Opdater status fra {0}",
    "Void invoice": "Ugyldig faktura",
    "Delete invoice": "Slet faktura",
    "Restore invoice": "Gendan faktura",
    "Mark unpaid": "Marker som ikke betalt",
    "Invoices": "Fakturaer",
    "Download to Excel": "Download til Excel",
    "Revenue split": "Opdeling af indtægter",
    "Tax": "Skat",
    "Description": "Beskrivelse",
    "Percent": "Procent",
    "Integration Id": "Integrations-id",
    "Integration Code": "Integrationskode",
    "Name on invoice": "Navn på faktura",
    "Restore": "Gendan",
    "Archive": "Arkiv",
    "Hide": "Skjul",
    "Are you sure?": "Er du sikker?",
    "Import finished!": "Importering afsluttet!",
    "Failed to import {0} records": "Kunne ikke importere {0} poster",
    "Download report": "Last ned rapport",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Resultat: tilføjet {0}, opdateret {1}, skippet {2}, fejl i import {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Resultat: tilføjet {0}, opdateret {1}, skippet {2}",
    "What’s next?": "Hvad er det næste?",
    "To work effectively with your client base, complete the following steps:": "For at arbejde effektivt med din klientgruppe bør du gennemføre følgende trin:",
    "Read more ›": "Læs mere >",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Derefter vises kun aktive importerede klienter. For at se alle klienter, skal du fjerne feltet \"Sidste import\".",
    "View clients": "Vis klienter",
    "Add <b>primary member</b> to every client.": "Tilføj <b>primære medlem</b> til hver klient.",
    "Add <b>task plan</b> to automate recurring tasks.": "Tilføj <b>opgaveplan</b> for at automatisere tilbagevendende opgaver.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Opsæt automatisk månedlig oversigt under appen {0} i Uku for at importere arbejdsmængden.",
    "Title": "Titel",
    "Field type": "Felttype",
    "Field name": "Feltnavn",
    "Group name": "Gruppe navn",
    "Choices": "Valgmuligheder",
    "Type each choice on a separate line": "Skriv hvert valg på en separat linje",
    "Required": "Påkrævet",
    "For all topics": "Til alle emner",
    "For specific topics": "Til specifikke emner",
    "Topics": "Emner",
    "Non-billable": "Kan ikke faktureres",
    "Edit task custom field": "Rediger opgave tilpasset felt",
    "Add task custom field": "Tilføj opgave tilpasset felt",
    "Edit client custom field": "Rediger brugerdefineret klientfelt",
    "Add client custom field": "Tilføj klient tilpasset felt",
    "Choice {0}": "Valg {0}",
    "Are you sure that you want to delete this custom field?": "Er du sikker på, at du vil slette dette brugerdefinerede felt?",
    "Warning!": "Advarsel!",
    "This custom field is in use. Do you wish to archive it?": "Dette brugerdefinerede felt er i brug. Ønsker du at arkivere det?",
    "Reconnect": "Tilslut igen",
    "Send test email": "Send test-e-mail",
    "Email address or username": "E-mailadresse eller brugernavn",
    "Other": "Andet",
    "Set default email server for company": "Indstil standard e-mail-server for virksomheden",
    "My default email": "Min standard e-mail",
    "Depends on": "Afhænger af",
    "Todo - Blocking": "At gøre - Blokering",
    "In progress - Blocking": "Igangværende - blokering",
    "In progress": "I gang",
    "Client code": "Kundekode",
    "Primary user": "Primær bruger",
    "Added date": "Tilføjet dato",
    "Updated": "Fornyet",
    "Contract count": "Antal kontrakter",
    "Integration": "Integration",
    "No data available": "Ingen data tilgængelig",
    "No results found": "Ingen resultater fundet",
    "Loading": "Indlæser",
    "Sort by": "Sorter efter",
    "Rows per page": "Rækker pr. side",
    "{0}-{1} of {2}": "{0}-{1} af {2}",
    "Ongoing": "Igangværende",
    "important": "vigtig",
    "Read more": "Læs mere",
    "Add to previous time entry": "Tilføj til tidligere tidsangivelse",
    "Add to next time entry": "Tilføj til næste tidsangivelse",
    "Add new task": "Tilføj ny opgave",
    "Cut previous time entry": "Klip tidligere tidsangivelse",
    "Cut next time entry": "Klip næste tidsangivelse",
    "Missing time entry": "Manglende tidsangivelse",
    "Overlapping time entries": "Overlappende tidsangivelser",
    "Member from custom fields": "Medlem fra brugerdefinerede felter",
    "Delegated to": "Delegeret til",
    "Delegated by": "Delegeret af",
    "Visible members": "Synlige medlemmer",
    "Member type": "Medlemstype",
    "Groups": "Grupper",
    "Custom field": "Brugerdefineret felt",
    "Contact search": "Kontakt til søgning",
    "Task start": "Start af opgave",
    "Task due": "Opgave til tiden",
    "Task finish": "Færdiggørelse af opgaver",
    "Custom date": "Valgfri dato",
    "Never": "Aldrig",
    "Agreed work is still expected": "Aftalt arbejde forventes stadig",
    "Accepted flextime": "Accepteret flextid",
    "Declined flextime": "Afvist flextid",
    "Cancelled flextime": "Aflyst flextid",
    "Updated flextime": "Opdateret",
    "Calendar deleted": "Kalender slettet",
    "Calendar created": "Kalender opretttet",
    "Calendar approved": "Kalender accepteret",
    "Calendar declined": "Kalender afvist",
    "Calendar updated": "Kalender opdateret",
    "Flextime balance updated": "Flextid balance opdateret",
    "Flextime": "Flextid",
    "Vacation": "Ferie",
    "Balance": "Balance",
    "Comment": "Kommentar",
    "History": "Historie",
    "Action": "Handling",
    "Who": "Hvem",
    "Take a vacation or mark an absence": "Hold ferie eller marker et fravær",
    "Away": "Væk",
    "Flextime bonus": "Flextime bonus",
    "Approver": "Godkender",
    "Vacation available": "Ferie tilgængelig",
    "Type": "Type",
    "Reduce agreed working hours": "Reducere aftalte arbejdstider",
    "Reject": "Afvis",
    "Approve": "Godkend",
    "away_type_Away": "Væk",
    "Sick leave": "Sygeorlov",
    "Parental leave": "Forældreorlov",
    "Working hours": "Arbejdstid",
    "Mon-Fri, 40h weekly, 8h daily": "Man-fre, 40 timer ugentligt, 8 timer dagligt",
    "Customize": "Tilpas",
    "Total": "I alt",
    "Settings": "Indstillinger",
    "Work on holidays": "Arbejde i ferier",
    "Expand": "Udvide",
    "Wait until event status": "Vent på event status",
    "Wait until project status": "Vent til projektstatus",
    "Week(s)": "Uge(r)",
    "Day(s)": "Dag(e)",
    "Rule": "Regel",
    "Depends on event": "Afhænger af begivenhed",
    "Depends on project": "Afhænger af projektet",
    "Due date in": "Udløbsdato om",
    "Status": "Status",
    "Select event": "Vælg event",
    "Select project": "Vælg projekt",
    "Find event...": "Find begivenhed...",
    "Find project...": "Find projekt...",
    "Custom recurrence": "Tilpasset gentagelse",
    "Every": "Hver",
    "In case of holiday": "I tilfælde af ferie",
    "Set time": "Fastsat tidspunkt",
    "Start time": "Start tidspunkt",
    "Repeat from": "Gentag fra",
    "Previous repeat from: {0}": "Forrige gentagelse fra: {0}",
    "On date": "På dato",
    "Plus days": "Plus dage",
    "Due date time": "Forfaldsdato tid",
    "Remove recurrence": "Fjern gentagelser",
    "Repeat": "Gentage",
    "month": "måned",
    "quarter": "kvarter",
    "year": "år",
    "1st month": "1. måned",
    "2nd month": "2. måned",
    "3rd month": "3. måned",
    "Day {0}": "Dag {0}",
    "Show before": "Vis før",
    "Keep the day": "Hold dagen",
    "Show after": "Vis efter",
    "From start date": "Fra startdato",
    "From beginning of the month": "Fra begyndelsen af måneden",
    "All days (Mon to Sun)": "Alle dage (Man til Søn)",
    "Mon to Fri (incl. holidays)": "Man til fre (inkl. Helligdage)",
    "Mon to Fri (excl. holidays)": "Man til fre (ekskl. Helligdage)",
    "1st": "1.",
    "2nd": "2.",
    "3rd": "3.",
    "Does not repeat": "Gentager ikke",
    "Daily": "Daglige",
    "Weekly on {0}": "Ugentligt den {0}",
    "Monthly on day {0}": "Månedligt på dag {0}",
    "Quarterly on {0} month {1} day": "Kvartalsvis på {0} måned {1} dag",
    "Yearly on {0} {1}": "Årligt den {0} {1}",
    "Custom...": "Brugerdefinerede...",
    "Incorrect time": "Forkert tid",
    "Add repeat": "Tilføj gentagelse",
    "Email added to queue": "E-mail tilføjet til køen",
    "Communication timeline": "Tidslinje for kommunikation",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktiver Email Appen i App Store for at sende automatiserede e-mails og se din tidligere og fremtidige kommunikation på ét sted.",
    "Go to App Store": "Opsæt app’en",
    "Unknown": "Ukendt",
    "<b>Email</b> from": "<b>E-mail</b> fra",
    "To": "Til",
    "Planned": "Planlagt",
    "Automated emails scheduled to be sent in the future": "Automatiserede e-mails, der er planlagt til at blive sendt i fremtiden",
    "Send e-mail": "Send e-mail",
    "Template unlinked": "Skabelon ubundet",
    "Icon": "Ikon",
    "Link name": "Link navn",
    "Link URL": "Link URL",
    "Open in new tab": "Åbn i ny fane",
    "Visible": "Synlig",
    "External": "Eksternt",
    "Not external": "Ikke ekstern",
    "Company default": "Virksomhedens standard",
    "Not visible": "Ikke synlig",
    "Use company default": "Brug virksomhedens standard",
    "or choose icon": "eller vælg et ikon",
    "Find member...": "Find medlem...",
    "I'll take it": "Jeg tager den",
    "Remove me": "Fjern mig",
    "Remove from task": "Fjern fra opgaven",
    "Learn more": "Lær mere",
    "Company settings edit is disabled by owner": "Redigering af virksomhedsindstillinger er deaktiveret af ejeren",
    "<b>Exported</b> {0} to {1}": "<b>Eksporteret</b> {0} til {1}",
    "<b>Sent to client</b> {0} from {1}": "<b>Sendt til klienten</b> {0} fra {1}",
    "<b>Paid {0}</b> {1}": "<b>Betalt {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Annulleret</b> {0}",
    "Do you wish to mark the task done for everyone?": "Ønsker du at markere, at opgaven er udført for alle?",
    "No, remove me": "Nej, fjern mig",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Opgaven vil ikke blive markeret som udført, men brugeren fjernes og tilføjes i stedet som følger af opgaven",
    "Invalid email": "Ugyldig email",
    "Accounting": "Regnskab",
    "General": "Generelt",
    "Advertising / Marketing/ PR": "Annoncering / Marketing / PR",
    "Architecture": "Arkitektur",
    "Construction": "Konstruktion",
    "Consulting - IT, software": "Rådgivning - IT, software",
    "Consulting - Management": "Rådgivning - ledelse",
    "Finance": "Finansiere",
    "Legal": "Gyldig",
    "Medicine / Pharmacy ": "Medicin / Apotek ",
    "Non-profit": "Non-profit",
    "Web design": "Web design",
    "Web development": "Web udvikling",
    "Max 140 characters": "Maks. 140 tegn",
    "Please complete the checklist": "Udfyld tjeklisten",
    "It is required to mark all checklist items as done": "Det er nødvendigt at markere alle tjeklisteelementer som færdige",
    "Please enter time spent": "Angiv den brugte tid",
    "Inserting time is essential for this client": "Det er essentielt at indsætte tid for denne klient",
    "Only me": "Kun mig",
    "Private": "Privat",
    "Edit note": "Rediger note",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Tilføj yderligere oplysninger om klienten, såsom specielle aftaler, adgangskoder osv.",
    "Edit": "Redigere",
    "Workdays": "Arbejdsdage",
    "Workhours": "Arbejdstimer",
    "Weeks": "Uger",
    "Clear filters": "Ryd filtre",
    "Save filters": "Gem filtre",
    "Expected": "Forventet",
    "Estimation": "Estimation",
    "Do you also want to postpone the due date?": "Vil du også udsætte forfaldsdatoen?",
    "{0} week": "{0} uge",
    "{0} weeks": "{0} uger",
    "Vacations": "Ferie",
    "Holidays": "Ferier",
    "Tax dates": "Skattedatoer",
    "Accounting news": "Regnskabsnyheder",
    "Company events": "Begivenheder i virksomheden",
    "Member birthdays": "Fødselsdage for medlemmer",
    "Contact birthdays": "Kontakt fødselsdage",
    "Group items": "Gruppér elementer",
    "Don't group": "Gruppér ikke",
    "{0} away": "{0} væk",
    "Member birthday | Member birthdays": "Medlemsfødselsdag | Medlemsfødselsdage",
    "Contact birthday | Contact birthdays": "Kontakt fødselsdag | Kontakt fødselsdage",
    "Contact birthday": "Kontaktpersons fødselsdato",
    "Member birthday": "Medlems fødselsdag",
    "Are you sure you wish to delete this link?": "Er du sikker på, at du vil slette dette link?",
    "Reference name": "Reference navn",
    "Reference link": "Reference link",
    "Free trial": "Gratis prøveversion",
    "Solo": "Solo",
    "Team": "Team",
    "Enterprise": "Enterprise",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Chrome-browser-plugin til Uku til at styre din opgave, klienter og tracke tid.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Konfigurer opgave/jobplaner for at automatisere dit workflow, tilføje emner, tilpasse felter og ændre i dine præferencer.",
    "Setup client groups, custom fields and modify your preferences.": "Konfigurer klientgrupper, tilpassede felter og rediger dine præferencer.",
    "test": "test",
    "Anti Money Laundering": "Anti hvidvaskning af penge",
    "Setup your customer AML and get instant reminders when auditing is due.": "Konfigurer din kundes AML, og få øjeblikkelige påmindelser, når revision skal udføres.",
    "flextime_description": "Administrer nemt balancen mellem arbejdsliv og privatliv.",
    "Smart Accounts": "SmartAccounts",
    "Automatically imports work statistics from your accounting software.": "Importerer automatisk statistik fra din regnskabssoftware.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Fremskynd din kundes faktureringsproces med prislister og smarte kontrakter.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Visuel rapport fortæller dig nøjagtigt, hvor rentabel eller urentabel din klient er.",
    "Emailing description": "Email beskrivelse",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Importer kunder, og automatiser din fakturering. Send alle fakturaer til e-conomic med kun fire klik.",
    "Xero": "Xero",
    "xero_description": "Integration with Xero",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Integration med QuickBooks Online",
    "Tripletex": "Tripletex",
    "tripletex_description": "Integrer med Tripletex",
    "Scoro": "Scoro",
    "Export sales invoices.": "Eksport af salgsfakturaer.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Integrer med Fortnox",
    "Magic button": "Magisk knap",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Med 1 klik - en hurtig og nem måde at udføre vigtige opgaver. For eksempel, et telefonopkald fra en klient.",
    "With suppliers, you make your projects and partners management more efficient.": "Med leverandører kan du gøre dit projekt- og partnerstyring mere effektiv.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Kraftfuld og fleksibel projektstyring til forskellige brugssituationer og workflows.",
    "client_portal_app_description": "Client portal simplifies collaboration with clients. Securely receive documents, give tasks, and share information.",
    "Chat": "Snak",
    "chat_app_description": "Enhance team collaboration, client communication, and overall efficiency with the Chat.",
    "Companies House": "Companies House",
    "companies_house_app_description": "Integrer med Companies House",
    "documents_app_description": "dokumenter_app_beskrivelse",
    "Connect and discover tools to help you manage your business.": "Opret forbindelse og opdag værktøjer, der hjælper dig med at administrere din virksomhed.",
    "Subscribe now": "Abonner nu",
    "Compare plans": "Sammenlign planer",
    "Add company": "Tilføj virksomhedskonto",
    "BETA": "BETA",
    "Setup": "Setup",
    "Power up": "Start op",
    "Integrations": "Integrationer",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hej! Vil du arbejde med et team og bruge ekstra funktioner? Intet problem, tilføj først din virksomhed!",
    "Read more about Uku plans": "Læs mere om Uku planerne",
    "Contact role": "Kontaktperson",
    "Contact roles": "Kontaktpersons roller",
    "Client groups": "Kundegrupper",
    "Client fields": "Kundefelter",
    "Contact fields": "Kontaktfelter",
    "View archive": "Vis arkiv",
    "Restore from archive": "Gendan fra arkiv",
    "Empty list": "Tom liste",
    "Task fields": "Opgavefelter",
    "task topics": "emner for opgaver",
    "Keep the task opened when starting the timer": "Hold opgaven åben, når du starter timeren",
    "task templates": "opgaveskabeloner",
    "Author": "Forfatter",
    "Duplicate": "Duplikere",
    "Uku task templates": "Uku-opgaveskabeloner",
    "Are you sure that you want to delete this task template?": "Er du sikker på, at du vil slette denne opgaveskabelon?",
    "Templates": "Skabeloner",
    "Overview": "Oversigt",
    "chat_app_overview_text": "<p class='title'>Uku Chat is a user-friendly and secure messaging tool tailored to streamline communication, collaboration, and task management.</p> <div class='body-2'><p>Key functionalities include:</p><ul><li>Real-time messaging: Send instant messages to team members and clients. It has options for direct messages, group chats, and dedicated channels for specific topics.</li><li>Task management: Create a new task from a conversation.</li><li>ChatGPT integration: Summarize the conversation, change the tone of voice, and request recommendations for response.</li><li>Customizable notifications: Tailor notifications to your preferences.</li></ul></div>",
    "Color": "Farve",
    "Are you sure to delete this field? You may lose the data.": "Er du sikker på, at du vil slette dette felt? Du kan miste data.",
    "Add field": "Tilføj felt",
    "Add section": "Tilføj sektion",
    "multiline": "flere linjer",
    "Import data": "Importer data",
    "Automate data collection with Smart Accounts": "Automatiser dataindsamling med Smart Accounts",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul> <li> Importer købs- og salgsposter, antal poster og indtastningslinjer tæller; </li> <li> Automatiser dataindsamling med SmartAccounts; </li> <li> Hurtigere og mere nøjagtig fakturering gennem automatisk dataudveksling. Uku indsamler oplysninger til at forberede kundernes fakturaer ét sted og gør fakturering effektiv. </li> </ul>",
    "xero_app_overview_text": "<p class='title'>Automate your billing process by connecting Xero to Uku.</p> <div class='body-2'><p>Benefits of the Xero integration:</p><ul><li>Import all your clients from Xero to Uku with just a couple of clicks</li><li>Import product codes and classificators to Uku</li><li>Create invoices automatically in Uku and send them to Xero</li></ul></div>",
    "Import clients from {0}": "Importer klienter fra {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Før du importerer klienter, skal du godkende med Xero og vælge virksomheden.",
    "Authorize Xero to start import": "Tillad Xero at starte import",
    "Failed to import clients": "Kunne ikke importere klienter",
    "Failed to connect to WS": "Kunne ikke oprette forbindelse til WS",
    "Import": "Importer",
    "emailing_app_overview_text": "<p class='title'><b>Fast and convenient client communication</b></p><div class='body-2'><p>Send one-time emails or set up automated emails. You can do both from the task view.</p><p><b>Automated emails</b></p><p>Add an automatic email to recurring tasks. For example, set up an automatic email \"Missing documents\" to the task \"Documents entry\" which will be sent out 2 days before the task starts. This way you have all necessary documents when starting working on the task.</p><p><b>Email templates</b></p><p>Save emails you often send conveniently as a template. This saves you the hassle of constantly composing messages with the same content.</p></div>",
    "Email signatures": "E-mail-signaturer",
    "Everyone": "Alle",
    "Access": "Adgang",
    "Creator": "Opretter",
    "Are you sure you want to delete this signature? Some emails will be affected": "Er du sikker på, at du vil slette denne signatur? Nogle e-mails vil blive påvirket",
    "Email addresses": "Email adresse",
    "Signatures": "Signaturer",
    "Send emails": "Send e-mails",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku integreres sikkert med din e-mail for at hjælpe dig med at administrere og automatisere kommunikation",
    "Use {0} address": "Brug {0}-adressen",
    "connect your email address": "forbind din e-mailadresse",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Forbind med Microsoft Exchange eller en anden e-mail-server (SMTP)",
    "Email integration reconnected": "E-mail-integration genoprettet",
    "Are you sure you want to delete this email integration?": "Er du sikker på, at du vil slette denne e-mail-integration?",
    "Email templates": "E-mail skabelon",
    "Add email template": "Tilføj e-mail skabelon",
    "Are you sure you want to save this template? Some tasks will be affected": "Er du sikker på, at du ønsker at gemme denne skabelon? Nogle opgaver vil blive påvirket",
    "Clients can leave task messages by replying to client portal email": "Kunder kan efterlade opgavebeskeder ved at svare på e-mail i kundeportalen",
    "Send a copy of client's response to member's inbox": "Send en kopi af kundens svar til medlemmets indbakke",
    "Email recipients can leave task comments by replying to a task email": "Modtagere af e-mails kan skrive kommentarer til opgaver ved at svare på en e-mail om en opgave",
    "economic_app_overview_text": "<p class='title'>Automate your billing process by connecting e-conomic to Uku</p><div class='body-2'><p>e-conomic integration enables you to:<ul><li>import all your clients from e-conomic to Uku with just a couple of clicks</li><li>import products and classificators from e-conomic to Uku</li><li>create invoices automatically in Uku and send them to e-conomic</li></ul></p></div>",
    "Default layout": "Standardlayout",
    "Change agreement ID": "Opdater aftale ID",
    "Failed to connect to server": "Det lykkedes ikke at oprette forbindelse til serveren",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "<div class='body-2'><p>Importer følgende data fra e-conomic til Uku:<ul><li>klienter,</li><li>produkter,</li><li>enheder,</li><li>Layout-skabeloner.</li></ul></p><p>I det næste trin kan du vælge de klienter, du vil tilføje eller opdatere.</p></div>.",
    "Connect e-conomic": "Forbind e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Før du importerer kunder, skal du forbinde Uku o-g economic. For at gøre dette skal du oprette en aftale med e-conomic og indtaste aftalens ID her.",
    "Step {0}": "Trin {0}",
    "Get agreement ID": "Hent aftale ID",
    "Insert agreement ID": "Indsæt aftale ID",
    "Connect": "Forbind",
    "quickbooks_app_overview_text": "<p class='title'>Automate your billing process by connecting QuickBooks Online to Uku.</p> <div class='body-2'><p>Benefits of the QuickBooks integration:</p><ul><li>Import all your clients from QuickBooks to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to QuickBooks.</li></ul></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku vil importere alle klienter, klientoplysninger og klassificeringsværktøjer fra QuickBooks. I det sidste trin kan du vælge, hvilke klienter du vil tilføje eller opdatere.",
    "Before importing clients, you need to connect with QuickBooks.": "Før du importerer klienter, skal du oprette forbindelse til QuickBooks.",
    "Connected to QuickBooks": "Forbundet til QuickBooks",
    "fortnox_app_overview_text": "<p class='title'>Automate your billing process by connecting Fortnox to Uku.</p> <div class='body-2'><p>Benefits of the Fortnox integration:</p><ul><li>Import all your clients from Fortnox to Uku with just a couple of clicks.</li><li>Import products and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Fortnox.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku vil importere alle klienter, klientoplysninger og klassificeringsværktøjer fra Fortnox. I det sidste trin kan du vælge, hvilke klienter du vil tilføje eller opdatere.",
    "Before importing clients, you need to connect with Fortnox.": "Før du importerer klienter, skal du oprette forbindelse til Fortnox.",
    "Connect to Fortnox": "Tilslut din Fortnox-konto ",
    "Connected to Fortnox": "Forbundet til Fortnox",
    "Delete template": "Slet skabelon",
    "Public": "Offentlig",
    "Workflow templates": "Skabeloner for workflows",
    "No workflow templates yet": "Ingen workflows skabeloner endnu",
    "Modified": "Modificeret",
    "Uku workflow templates": "Uku workflow-skabeloner",
    "Are you sure you wish to delete this workflow?": "Er du sikker på, at du ønsker at slette dette workflow?",
    "Project fields": "Projekt felter",
    "Progress step": "Fremskridt step",
    "Rename project": "Omdøb projekt",
    "Project statuses": "Projekt status",
    "You can use the statuses to restrict the workflow.": "Du kan bruge denne status til at begrænse workflowet.",
    "Project phases": "Projektets faser",
    "Make your progress beautiful.": "Optimer din udvikling.",
    "Permissions": "Rettigheder",
    "Users can manage workflow templates": "Brugere kan administrere workflowsskabeloner",
    "project_app_overview_text": "Handle projects from initiation to completion with ease.",
    "project_app_overview_description": "<div class=‘body-2’><p>Plan and execute tasks, track your projects, and never have a task fall through the cracks.</p><p>Key features:</p><ul><li><b>Creating projects: </b>Create projects using ready-made, customisable project templates. Keep non-accounting projects like client or employee onboarding separate from daily tasks. You can also start projects from scratch to tailor projects precisely to your needs.</li><li><b>Task management: </b>Break projects into tasks, assign responsibilities, and set due dates and dependencies. Separate extra services from daily accounting tasks.</li><li><b>Progress tracking: </b>The interactive project overview helps visualise progress, allowing for effective project schedule management. For instance, project tasks, like onboarding and off-boarding templates, look different from your regular tasks.</li><li><b>Customisation: </b>Tailor projects to your organisation’s needs with customisable fields and workflow templates. Have tasks depend on the project’s start or due date rather than a specific date of the month, providing flexibility and adaptability to project management.</li></ul></div>",
    "Configure summary task": "Konfigurer oversigtsopgave",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku genererer opgave med følgende titel og emne den sidste dag i måneden.",
    "Task title": "Opgavens titel",
    "Recurrence": "Tilbagevenden",
    "Count changes from previous periods": "Antal ændringer fra tidligere perioder",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Hvis den er aktiveret, vil ændringer i tidligere perioder blive tilføjet til den aktuelle måned. Hvis den er deaktiveret, vil der ikke blive taget højde for ændringer i tidligere perioder.",
    "Configure data fields": "Konfigurer datafelter",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Vælg det tilsvarende Uku-felt for hvert importerede felt. Samme felter vil blive opsummeret. Hvis felter lades stå tomme, vil disse blive ignoreret.",
    "New custom field": "Nyt brugerdefineret felt",
    "Show more": "Vis mere",
    "Every month": "Hver måned",
    "Last day of the month": "Sidste dag i måneden",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Dag {0} i næste måned",
    "Settings saved": "Indstillinger gemt",
    "Uku will let you know when it is ready.": "Uku giver dig besked, når den er klar.",
    "Reload data": "Genindlæs data",
    "months": "måneder",
    "This will overwrite existing summary tasks new values.": "Dette vil overskrive eksisterende oversigtsopgaver med nye værdier.",
    "Overwrite": "Overskriv",
    "Automate your anti money laundering process": "Automatiser din anti hvidvaskningsproces",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Du er ved at aktivere anti penge hvidvasknings processen. Imens vil nye felter blive tilføjet til dine klienters oplysninger og dit system vil begynde at huske dig på at opdatere dem.<br><br>Yderligere felter er: <ul><li>Risiko profil</il><li>Profil gyldig til</il><li>AML status</il><li>Dokument nr.</il><li>Dokument gyldigt indtil</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Du er ved at aktivere anti penge hvidvasknings processen. Imens vil nye felter blive tilføjet til dine klienters oplysninger og dit system vil begynde at huske dig på at opdatere dem.<br><br>Yderligere felter er: <ul><li>Risiko profil</il><li>Næste AML check</il><li>Godkendt/Afvist</il><li>ID type</il><li>ID Nummer</il><li>Udløbsdato</il><li>Yderligere kontrol</li></ul>",
    "Do not change client custom fields created by Uku": "Ændre ikke i klientens brugerfelter oprettet af Uku",
    "day(s) before": "dag(e) før",
    "Task name": "Opgave navn",
    "Assigned": "Tildelt",
    "Note": "Bemærk",
    "Manual run": "Manuel aktivering",
    "Create a task when the document expires": "Opret en opgave, når dokumentet udløber",
    "Create a task when the risk profile must be updated": "Opret en opgave, når risikoprofilen skal opdateres",
    "Flextime period": "Flextime periode",
    "Confirmation period": "Bekræftelsesperiode",
    "Weekly": "Ugentlig",
    "Add agreement": "Tilføj aftale",
    "flextime_app_overview_text": "<p class='title'>Få et overblik over dit teams arbejdstimer, overtid og feriebalance.</p> <div class='body-2'><p></p><p>Fordele ved Flextime:</p><ul><li>Praktisk overblik over arbejde og overtid</li><li>Lettilgængelig feriehåndtering og balanceoverblik</li><li>Nem dataeksport til din bogholder</li></ul></div>",
    "supplier_app_overview_text": "Administrer dine leverandører og partnere.",
    "supplier_app_overview_description": "<div class='body-2'><p>Your partners and third party organisations can be managed here in a separate register. You will no longer have to keep a list of contacts in an Excel sheet.</p></div>",
    "Supplier type": "Leverandørtype",
    "Parent type": "Parent type",
    "Edit supplier type": "Rediger leverandørtype",
    "New supplier type": "Ny leverandørtype",
    "Are you sure you wish to delete this supplier type?": "Er du sikker på, at du ønsker at slette denne leverandørtype?",
    "Types": "Typer",
    "Supplier types": "Leverandørtyper",
    "No supplier types yet": "Ingen leverandørtyper fundet",
    "tripletex_app_overview_text": "<p class='title'>Automate your billing process by connecting Tripletex to Uku.</p> <div class='body-2'><p>Benefits of the Tripletex integration:</p><ul><li>Import all your clients from Tripletex to Uku with just a couple of clicks.</li><li>Import products & services and classificators to Uku.</li><li>Create invoices automatically in Uku and send them to Tripletex.</li></ul></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku importerer alle klienter, klientoplysninger og klassifikatorer fra Tripletex. I det sidste trin kan du vælge, hvilke klienter du vil tilføje eller opdatere.",
    "Connect Tripletex": "Tilslut Tripletex",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Før du importerer klienter, skal du forbinde Uku og Tripletex-softwaren. For at gøre dette skal du oprette et medarbejder-token og indtaste det her.",
    "Get employee token": "Hent medarbejderens token",
    "Insert employee token": "Indsæt medarbejder-token",
    "Install": "Installere",
    "Open Chrome browser to install": "Åbn Chrome-browseren for at installere",
    "Works with your online accounting software.": "Arbejder med din online regnskabssoftware.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Nye opgaver kan komme som lyn fra en klar himmel og derfor er Mini Uku din bedste ven. Lige meget om du laver bankoverførsler eller arbejder med din revisor software; med Mini Uku kan du tilføje nye opgaver, administre din tid og holde styr på alle dine meddelelser fra hvilken som helst hjemmeside.<br><br>Kun et klik på ugle ikonet og du får overblik over hele din arbejdsdag og hjælp med en mere effektivt planlægning.",
    "merit_aktiva_app_overview_text_pl": "merit_aktiva_app_overview_text_pl",
    "merit_aktiva_app_overview_text": "<p class='title'>Import clients and the volume of work to get one report with work done data for all your clients.</p><div class='body-2'><p>Make your data collection fast and accurate with Merit Aktiva and Uku integration. Uku automatically imports sales and purchase invoices, documents, entries, etc. for each client and performs volume of work and time-entries in one interactive report. No more switching between clients in your accounting software to get information about documents processed to create invoices or monitor client performance. Compared to Merit, Uku imports the actual amount of entries for last month, taking into account all changes that were inserted into previous periods. Meaning that you don't have to remember or write down any changes you have made - Uku has all that information and so will you. Automated data collection saves you time and eliminates human errors.</p><p>Uku and Merit Aktiva integration helps you to:</p><p><ul><li>Quickly and accurately gather data - volume of work is imported to Uku from Merit automatically</li><li>Analyse workload and time by having a full overview of work done and time spent on clients</li><li>Automate the creation of monthly summaries </li><li>Get an overview of the actual workload each month</li></ul></p><p>With Uku - Merit integration you can import the amount of:</p><p><ul><li>Documents</li><li>Entries</li><li>Sales invoices</li><li>Purchase invoices</li><li>Bank entries</li><li>Cash entries</li><li>VAT entries</li><li>Stock entries</li><li>Etc.</li></ul></p></div>",
    "Import clients": "Importer klienter",
    "documents_app_overview_text": "dokumenter_app_oversigt_tekst",
    "Connect your existing document management system": "Forbind dit eksisterende dokumenthåndteringssystem",
    "Main folder": "Hovedmappe",
    "Under this folder, Uku automatically creates folders for each client.": "Under denne mappe opretter Uku automatisk mapper for hver klient.",
    "You can customize each client folder separately under client settings.": "Du kan tilpasse hver enkelt klientmappe separat under klientindstillinger.",
    "Automatically create Public folder for client files and Private folder for member files": "Opret automatisk en offentlig mappe til klientfiler og en privat mappe til medlemsfiler",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Opret automatisk år/måned-undermapper under hver klient til sortering af filer",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Opret automatisk undermapper til noter og skabeloner under hver klient til sortering af filer",
    "Add task files added by Members": "Tilføj opgavefiler tilføjet af medlemmer",
    "Add task files added by Clients (from emails and client portal)": "Tilføj opgavefiler tilføjet af klienter (fra e-mails og klientportal)",
    "Backup files to Uku file storage": "Sikkerhedskopier filer til Uku fillager",
    "Perfect example": "Perfekt eksempel",
    "You are about to disconnect this service.": "Du er ved at afbryde forbindelsen til denne tjeneste.",
    "Google Drive": "Google Drev",
    "OneDrive": "OneDrive",
    "Select folder": "Vælg mappe",
    "Manage": "Administrer",
    "Refresh": "Opdater",
    "Be aware of the issues before they become problems": "Vær opmærksom på problemerne, før de bliver for store",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Sammenligning i realtid af kundekontrakten og det udførte arbejde;</li><li>Vær opmærksom på problemerne, før de opstår;</li><li>Selv med faste priser er du nødt til at have interne målinger. Kontroller gyldigheden af kundens aftale ved at sammenligne den med det udførte arbejde.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku's Client Portal improves your service by simplifying communication between accountants and clients. With Uku's Client Portal, you can speed up communication, reduce email dependency, and offer a secure document-sharing and communication platform.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Client Portals features include:</p><ul><li><b>Magic Links:</b> Client's hassle-free login without usernames and passwords.</li><li><b>Document Digitisation:</b> Submit items to your accounting software with one click.</li><li><b>Client Communication:</b> Assign tasks to clients and send messages fast.</li><li><b>Automatic Reminders:</b> Reduce the amount of manual follow-ups, check statuses: seen, done.</li><li><b>Multilingual Interface:</b> Supports multiple languages for a personalised experience.</li><li><b>Customisable Branding:</b> Add logos, icons, colours and a welcome video to make your clients feel at home.</li></ul><p></p><p>Some Client Portal use cases:</p><p><b>1. Get Client Information:</b></p><ul><li>Add recurring tasks with document requirements.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Clients upload documents and answer queries in the Client Portal.</li></ul><p></p><p><b>2. Make Finance Reviews:</b></p><ul><li>Add monthly recurring tasks with meeting links.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>Send the client a meeting memo with a recorded video.</li></ul><p></p><p><b>3. Onboard Your Client:</b></p><ul><li>Add an onboarding task from the template.</li><li>The client gets an email and reminder with magic link to the Client Portal.</li><li>The client fills out the checklist (accesses, reports).</li></ul><p></p><p>These use cases demonstrate Uku's Client Portal's task management and communication efficiency.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Read more &rsaquo;</a></p></div>",
    "Branding": "Branding",
    "Subdomain": "Underdomæne",
    "Default language": "Standardsprog",
    "Client portal URL in other languages": "Klientportal-URL på andre sprog",
    "Copy URL": "Kopiér URL",
    "Trademark": "Varemærke",
    "Trademark text color": "Varemærke tekstfarve",
    "Choose color": "Vælg farve",
    "Brand background color": "Brand baggrundsfarve",
    "Logo": "Logo",
    "Delete logo": "Slet logo",
    "Upload logo file": "Upload logofil",
    "Max. dimensions 180 x 60 px": "Maks. mål 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Slet ikon",
    "Upload icon file": "Upload ikonfil",
    "Recommended size 260 x 260 px": "Anbefalet størrelse 260 x 260 px",
    "Company description": "Virksomhedsbeskrivelse",
    "Displayed on the login page.": "Vises på login-siden.",
    "Describe here what services you offer and how you help your clients.": "Beskriv her, hvilke tjenester du tilbyder, og hvordan du hjælper dine kunder.",
    "Welcome video": "Velkomstvideo",
    "Displayed on the login page when your client contact enters for the first time": "Vises på login-siden, når din kundekontakt kommer ind for første gang",
    "Use Uku video": "Brug Uku-video",
    "View": "View",
    "Use other video": "Brug anden video",
    "Youtube or Vimeo video URL": "Youtube eller Vimeo video URL",
    "Show file upload box for client tasks": "Vis filupload-boks for klientopgaver",
    "Invalid data": "Ugyldige data",
    "Client portal preview": "Forhåndsvisning af klientportal",
    "Client portal URL for {0} copied to clipboard": "Klientportal-URL for {0} kopieret til udklipsholder",
    "Personalize your client portal's menu": "Gør din klientportals menu personlig",
    "Menu links saved": "Gemte menulinks",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Tilføj tilpassede links til vigtige elementer som f.eks: Dokumenter, finansielle rapporter, onboarding-formularer, feedback-undersøgelser, serviceaftaler, priser, instruktioner, fakturaer. I dette afsnit kan du opbygge menustrukturen, indstille rækkefølgen af emner og definere standardlinks. Du kan også tilpasse navne og links for hver enkelt klient. Kun menuer med definerede links vises i klientportalen. <a href='/api/help_link/cp_menu_links' target='_blank'>Læs mere '</a>",
    "Menu links": "Menulinks",
    "Add recurring task": "Tilføj tilbagevendende opgave",
    "Reminder tasks updated": "Opdatering af påmindelsesopgaver",
    "Create recurring tasks for Companies House clients.": "Opret tilbagevendende opgaver for Companies House-kunder.",
    "companies_house_app_overview_text": "Companies House",
    "buttons": "knapper",
    "Show to me": "Vis mig",
    "magic_button_app_overview_text": "<p class='title'>With one click, add a new task and start the timer.</p> <div class='body-2'><p>Magic buttons allow you to insert urgent work (phone call, email) conveniently.</p><p>Insert all tasks immediately to Uku</p><p>Magic buttons allow you to add urgent tasks (phone call, email) to Uku conveniently. That ensures tasks are inserted into Uku properly.</p><p>Magic buttons:</p><ul><li>Insert a new task and start the timer with one click (move to + button in the header).</li><li>Customize magic buttons according to your needs.</li><li>Modify the client or other information afterward.</li><li>Continue with the previous task that you can quickly access from the magic buttons list.</li></ul></div>",
    "Buttons": "Knapper",
    "Member rights": "Medlemsrettigheder",
    "Allow managers to view and create their client contracts and invoices": "Giv managere mulighed for at se og oprette deres klientkontrakter og fakturaer",
    "Allow members to view and create their client invoices": "Giv medlemmerne mulighed for at se og oprette deres klientfakturaer",
    "Allow members to view their client invoices": "Giv medlemmerne mulighed for at se deres klientfakturaer",
    "Allow only owners to add and update products": "Tillad kun ejere at tilføje og opdatere produkter",
    "Allow members to send invoices to clients": "Tillad medlemmer at sende fakturaer til kunder",
    "Allow members to confirm their client invoice rows": "Tillad medlemmerne at bekræfte rækkerne i deres klientfakturaer",
    "Send PDF invoice": "Send PDF-faktura",
    "Invoice email": "Faktura e-mail",
    "Default rounding": "Standardafrunding",
    "Round all times up to x": "Rund alle tider op til x",
    "Time rounding increment": "Afrunding af tidsforøgelse",
    "Apply time rounding to": "Anvend tidsafrunding på",
    "Default configuration": "Standardkonfiguration",
    "Invoice date": "Fakturadato",
    "Invoice entry date": "Dato for fakturering",
    "Bill tracked time by": "Bill fulgte tiden ved at",
    "Bill task field by": "Fakturer opgavefelt efter",
    "Create one invoice merging invoices from the same period": "Opret én faktura, der samler fakturaer fra samme periode",
    "Invoices from the same period": "Fakturaer fra samme periode",
    "Hide zero sum lines": "Skjul nulsumslinjer",
    "By default, time entry is billable": "Som standard er tidsregistrering fakturerbar",
    "Invoice number": "Faktura nummer",
    "Prefix": "Præfiks",
    "Suffix": "Suffiks",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Faktureringsindstillinger gemt",
    "billing_app_overview_text": "<p class='title'>Speed up your client billing process with flexible price lists and smart contracts.</p><div class='body-2'><p>Automate your invoicing process and save valuable time from generating invoices. Uku dynamic billing creates all your invoices based on the work done and helps you to earn fair profit from your clients. No more data collection from different softwares or excel sheets - Uku has it all and puts together invoices for you. All left for you to do is scan through the invoices and send them out.</p><p>Uku billing:</p><p><ul><li><b>Saves time</b> by reducing administrative working hours</li><li><b>Increases revenue</b> by preparing invoices based on all work done</li><li><b>Reduces error rates / avoids incorrect invoicing</b> by minimising human intervention</li><li><b>Ensures steady revenue stream</b> with more timely billing</li><li><b>Increases transparency</b> thanks to detailed and easily accessible customer agreements</li><li><b>Increases accuracy</b> by remembering all contract changes from day 1</li><li><b>Allows flexibility, scalability</b> and provides better customer experience for your client</li></ul></p><p>Uku supports all kinds of pricing models - whatever agreements you have made with your clients, we got your back. Uku invoicing allows you to create products including:</p><p><ul><li>Hourly pricing (e.g accountant price, assistant price)</li><li>Fixed fee pricing (e.g packages, annually agreed price)</li><li>Value based pricing (e.g perceived value of service(s))</li><li>Volume of work based pricing (e.g amount of documents processed)</li><li>Additional services pricing (e.g annual accounts, consultation)</li><li>Combination of several models (e.g fixed fee pricing + extra hours worked; volume of work + consultation hours; etc.)</li></ul></p><p>After the invoices have been created by Uku, you can review them, make changes (if necessary) and send them all out in bulk.</p><p><a href='http://help.getuku.com/en/articles/5716548-how-does-billing-work-in-uku' taget='_blank'>Learn more about Uku billing here.</a> </p><p>If you want to implement Uku billing and would like to have a consultation with our expert, please <a href='https://calendly.com/getuku/uku-billing' target='_blank'>book a time here</a> (free of charge).</p></div>",
    "Products": "Produkter",
    "Contract templates": "Skabeloner til kontrakter",
    "Invoice templates": "Faktura-skabeloner",
    "Tools": "Værktøjer",
    "Replace tax": "Udskift skat",
    "Old tax": "Gammel skat",
    "New tax": "Ny skat",
    "Find tax": "Find skat",
    "Replace VAT in products": "Erstat moms af produkter",
    "Replace VAT in master contracts": "Erstat moms i master kontrakter",
    "Replace VAT in client contracts & draft invoices": "Erstat moms i kundekontrakter & udkast til fakturaer",
    "Replace VAT values": "Erstat momsværdier",
    "This action cannot be undone": "Denne handling kan ikke fortrydes",
    "Replace": "Erstat",
    "Result": "Resultat",
    "PDF templates": "PDF-skabeloner",
    "E-mail templates": "E-mailskabeloner",
    "Edit PDF template": "Rediger e-mailskabeloner",
    "Import classificators": "Importer klassificeringer",
    "products": "produkter",
    "product": "produkt",
    "Product / service": "Produkt / service",
    "Calculate": "Udregn",
    "Article": "Artikel",
    "Resource": "Ressource",
    "Cost center": "Omkostningscenter",
    "Taxes": "Moms",
    "Code": "Kode",
    "Source": "Kilde",
    "Articles": "Artikler",
    "Resources": "Ressourcer",
    "Cost centers": "Omkostningscentre",
    "Units": "Enheder",
    "Unit": "Enhed",
    "Bank accounts": "Bankkonti",
    "Bank account": "Bankkonto",
    "Bank name": "Bank navn",
    "IBAN": "IBAN",
    "SWIFT code": "SWIFT kode",
    "Do you wish to import only new data or also overwrite existing?": "Vil du kun importere nye data eller også overskrive eksisterende?",
    "Only new": "Kun nye",
    "New items will be added. Existing ones will remain unchanged by import.": "Nye elementer vil blive tilføjet. Eksisterende forbliver uændrede ved import.",
    "Import everything": "Importer alt",
    "Connect accounting service": "Forbind regnskabstjeneste",
    "Service": "Service",
    "API ID": "API ID",
    "API key": "API Nøgle",
    "Company Account Id": "Virksomhedskonto-id",
    "Api secret": "Api hemmelighed",
    "E-conomic": "e-conomic",
    "SmartAccounts": "SmartAccounts",
    "Test": "Test",
    "Lock time entries": "Låsetidsindtastninger",
    "Owner rights": "Ejerens rettigheder",
    "Disable company settings edit for all members": "Deaktiver redigering af virksomhedsindstillinger for alle medlemmer",
    "Disable personal clients for members": "Deaktiver personlige klienter for medlemmer",
    "Show member birthdays": "Vis fødselsdage for medlemmer",
    "Show contact birthdays": "Vis kontaktpersoners fødselsdage",
    "Weekly @ Sun {0}": "Ugentlig @ Søn {0}",
    "Monthly @ last day of month": "Månedligt @ sidste dag i måneden",
    "Company event list": "Liste over firmabegivenheder",
    "How long?": "Hvor længe?",
    "Invoice no.": "Faktura nr.",
    "Login options": "Login muligheder",
    "Tenant ID (optional)": "Tenant ID (valgfri)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Tilføj Active Directory-tenant-id, hvis kun brugere, der tilhører denne lejer, har tilladelse til at oprette forbindelse",
    "How to find ID’s?": "Hvordan finder man ID’er?",
    "Microsoft connected": "Microsoft har forbindelse",
    "Google connected": "Google har forbindelse",
    "Edit company": "Rediger firma",
    "Timezone": "Tidszone",
    "VAT number": "Momsnummer",
    "Company number": "Registreringskode",
    "Subscription plan": "Abonnementsplan",
    "Payment failed": "Betalingen mislykkedes",
    "Retry payment": "Forsøg betaling igen",
    "Next payment": "Næste betaling",
    "Update payment method": "Opdater betalingsmetode",
    "Plan": "Plan",
    "Choose a plan": "Vælg en plan",
    "Change plan": "Skift plan",
    "{0}-day free trial until {1}": "{0}-dages gratis prøveperiode indtil {1}",
    "monthly": "månedlige",
    "yearly": "årligt",
    "{0} member": "{0} medlem",
    "{0} members": "{0} medlemmer",
    "{0} plan": "{0} plan",
    "Cancelled (valid until {0})": "Annulleret (gyldig indtil {0})",
    "Your trial expired on {0}": "Din prøveperiode udløb den {0}",
    "Your subscription expired on {0}": "Dit abonnement udløb den {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Det er dejligt at se dig! Hvis du gerne vil i gang med et Uku-abonnement, skal du klikke på Vælg en plan",
    "Save {0} by paying for a year!": "Spar {0} ved at betale I et år!",
    "Choose plan": "Vælg pakke",
    "Pay annually": "Betal årligt",
    "Instructions sent!": "Instruktioner sendt!",
    "Instructions for resetting your password have been sent to": "Instruktioner til nulstilling af din adgangskode er sendt til",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Du vil modtage denne e-mail inden for 5 minutter. Husk også at tjekke din spam-mappe.",
    "Back to login page": "Tilbage til login-siden",
    "Get new password": "Få nyt kodeord",
    "Pick a password": "Vælg et kodeord",
    "Use minimum 8 characters with letters & numbers": "Brug mindst 8 tegn med bogstaver og tal",
    "Create your Uku Account": "Opret din Uku-konto",
    "Connect your Xero Account": "Tilslut din Xero-konto",
    "Phone": "Telefon",
    "I agree to the": "Jeg er enig i",
    "Terms of Service": "Servicevilkår",
    "Next": "Næste",
    "Having trouble?": "Har du problemer?",
    "We can help": "Vi kan hjælpe",
    "Log in instead": "Log ind i stedet",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Det bedste regnskabsværktøj på markedet. Automatiserede workflows, tidsregistrering, rapporter, overvågning, CRM. Få arbejdet udført til tiden og med fortjeneste. Prøv gratis!",
    "You are invited to join": "Du er inviteret til at være en del af",
    "Accept invitation": "Accepter invitationen",
    "Check your email": "Tjek din e-mail",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Jeg sendte dig en e-mail med et link for at aktivere din konto. Dette er vigtigt for at sikre din kontos sikkerhed.",
    "Go to": "Gå til",
    "Need a new password?": "Brug for et nyt kodeord?",
    "Enter your e-mail address and we will send you directions for changing your password": "Indtast din e-mail-adresse, så sender vi dig vejledning til ændring af din adgangskode",
    "Send me instructions": "Send mig instruktioner",
    "Never mind, go back": "Glem det, gå tilbage",
    "No login options enabled. Please contact the company owner": "Ingen login-muligheder aktiveret. Kontakt venligst virksomhedens ejer",
    "Log in to Uku": "Log ind på Uku",
    "Forgot password?": "Glemt kodeord?",
    "Don't have account?": "Har du ikke konto?",
    "Create account": "Opret konto",
    "Total items:": "Samlet antal varer:",
    "Add new": "Tilføj ny",
    "Amount": "Beløb",
    "Account created range": "Konto oprettet i periode",
    "Usage limit": "Brugsgrænse",
    "Valid until": "Gyldig indtil",
    "Edit help link": "Rediger link til hjælp",
    "New help link": "Nyt hjælpelink",
    "Name key": "Navn nøgle",
    "Country code": "Landekode",
    "Period (months)": "Periode (måneder)",
    "Account created from": "Konto oprettet fra",
    "Account created until": "Konto oprettet indtil",
    "Used count": "Anvendt antal",
    "Sum": "Sum",
    "Create voucher": "Opret kupon",
    "Edit voucher": "Rediger kupon",
    "Are you sure to delete this voucher?": "Er du sikker på, at du vil slette denne kupon?",
    "row | rows": "række | rækker",
    "Add event": "Tilføj begivenhed",
    "Are you sure you wish to delete this event?": "Er du sikker på, at du vil slette denne begivenhed?",
    "event | events": "begivenhed | begivenheder",
    "Security object id": "Sikkerhedsobjekt-id",
    "Direct rights": "Direkte rettigheder",
    "Computed rights": "Beregnede rettigheder",
    "Add link": "Tilføj link",
    "Are you sure you wish to delete this entry?": "Er du sikker på, at du vil slette denne post?",
    "link | links": "link | links",
    "Event type": "Begivenhedstype",
    "Date from": "Dato fra",
    "Date until": "Dato indtil",
    "Shortened by h": "Forkortet med h",
    "Category": "Kategori",
    "demo | demos": "demo | demoer",
    "Companies": "Virksomheder",
    "Leads": "Kundeemner",
    "Demos": "Demoer",
    "Vouchers": "Værdikuponer",
    "KPI": "KPI",
    "Activity log": "Aktivitetslog",
    "Notifications": "Meddelelser",
    "Me": "Mig",
    "Important notifications will appear here.": "Vigtige meddelelser vises her.",
    "Back": "Tilbage",
    "Return to UKU": "Tilbage til UKU",
    "Choose plan for {0}": "Vælg plan for {0}",
    "First payment will be made after the end of the trial period.": "Første betaling vil blive foretaget efter prøveperiodens udløb.",
    "Members and subscription can always be changed.": "Medlemmer og abonnement kan altid ændres.",
    "Your subscription is externally managed by Xero": "Dit abonnement administreres eksternt af Xero",
    "Select plan": "Vælg plan",
    "Billing period": "Faktureringsperiode",
    "Compare features": "Sammenlign funktioner",
    "Cancel uku subscription": "Annuller uku-abonnementet",
    "{0} discount": "{0} rabat",
    "You have currently<br />{0} active member": "Du har i øjeblikket<br />{0} aktive brugere",
    "You have currently<br />{0} active members": "Du har i øjeblikket<br />{0} aktive medlemmer",
    "Select yearly plan": "Vælg årligt plan",
    "Select monthly plan": "Vælg en månedlig plan",
    "Attention!": "Opmærksomhed!",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Hvis du ønsker at bruge Uku gratis, skal du deaktivere din konto og fortsætte med {0} plan",
    "per member/month (billed yearly)": "pr. medlem/måned (faktureres årligt)",
    "or {0} per member/month (monthly)": "eller {0} pr. medlem/måned (månedligt)",
    "Everything in {0}, plus:": "Alt I {0} plus:",
    "Compare plans, feature-by-feature": "Sammenlign pakker, funktion for funktion",
    "Deactivate account": "Deaktivere konto",
    "Are you sure to deactivate {0} account?": "Er du sikker på, at du vil deaktivere {0} konto?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Hvis du vælger at fortsætte med freelancer-pakken, deaktiveres din firmakonto. Data, der er relateret til denne firma, fjernes.",
    "Deactivate": "Deaktivere",
    "Teamwork": "Teamwork",
    "Unlimited clients + import": "Ubegrænset antal kunder + import",
    "Access management": "Adgangsstyring",
    "Custom fields": "Brugerdefinerede felter",
    "Live chat support": "Live chat support",
    "AML": "AML",
    "API": "API",
    "Client Portal": "Kundeportal",
    "New!": "Nyt!",
    "Custom integrations": "Brugerdefinerede integrationer",
    "Assisted clients import": "Import af assisterede kunder",
    "Tailor-made team workshop": "Skræddersyet team-workshop",
    "Early access to features": "Tidlig adgang til funktioner",
    "Pay by invoice": "Betal efter faktura",
    "Dedicated account manager": "Dedikeret account manager",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Hej! Din prøveperiode er slut. Vælg venligst {0} abonnementspakke for at fortsætte arbejdet",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Hej! Du skal opgradere {0} abonnementspakke for at bruge denne funktion",
    "Waiting for the subscription to complete": "Venter på, at abonnementet afsluttes",
    "Edit VAT number": "Rediger momsnummer",
    "VAT": "Moms",
    "This is subscription period amount.": "Dette er beløbet for abonnementsperioden.",
    "You save yearly {0}": "Du sparer hvert år {0}",
    "Add voucher": "Tilføj kupon",
    "Existing credit": "Eksisterende kredit",
    "Current payment": "Aktuel betaling",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Dette er det aktuelle betalingsbeløb. Din bank kræver også en bekræftelse af beløbet for abonnementsperioden.",
    "Confirm subscription {0}": "Bekræft abonnement {0}",
    "Your subscription will renew on": "Dit abonnement vil blive fornyet den",
    "Thank you for believing in us!": "Tak, fordi du tror på os!",
    "Uku team": "Uku-team",
    "Voucher {1} (-{0}%)": "Voucher {1} (-{0}%)",
    "Voucher {0}": "Kupon {0}",
    "New plan": "Ny plan",
    "Changed plan": "Ændret plan",
    "Add {0} member": "Tilføj {0} medlem",
    "Add {0} members": "Tilføj {0} medlemmer",
    "Remove {0} member": "Fjern {0} medlem",
    "Remove {0} members": "Fjern {0} medlemmer",
    "No changes to plan": "Ingen ændringer i planen",
    "Discount -{0}% with Yearly subscription": "Rabat - {0}% med årligt abonnement",
    "Yearly discounted price (-{0}%)": "Årlig diskonteret pris (-{0}%)",
    "Subscription updated": "Abonnementet er opdateret",
    "Please wait": "Vent venligst",
    "Your payment failed": "Din betaling mislykkedes",
    "Please check that you entered the data correctly or use another card": "Kontroller, at du har indtastet dataene korrekt, eller brug et andet kort",
    "Try again": "Prøv igen",
    "Pay": "Betale",
    "Payment": "Betaling",
    "Payment method updated": "Betalingsmetode opdateret",
    "Edit member": "Rediger medlem",
    "First name": "Fornavn",
    "Last name": "Efternavn",
    "External ID": "Eksternt ID",
    "Select groups": "Vælg grupper",
    "Administrator": "Administrator",
    "Invite sent": "Invitation sendt",
    "Activate member": "Aktiver medlem",
    "Deactivate member": "Deaktiver medlem",
    "Invited": "Inviteret",
    "Paid member": "Betalt medlem",
    "Send an invitation": "Send en invitation",
    "Limited": "Begrænset",
    "No invite, no access": "Ingen invitation, ingen adgang",
    "Free until activated": "Gratis indtil aktivering",
    "No access, no charge": "Ingen adgang, ingen betaling",
    "Hidden member": "Skjult medlem",
    "Edit members": "Rediger medlemmer",
    "Select user": "Vælg bruger",
    "Member will be assigned to every selected client": "Medlem vil blive tildelt til alle valgte klienter",
    "Member will be removed from all selected clients": "Medlem vil blive fjernet fra alle valgte kunder",
    "Assign user": "Tildel bruger",
    "Set as primary user": "Indstil som primær bruger",
    "Added as a default user when adding a task plan": "Tilføjet som standardbruger ved tilføjelse af en opgaveplan",
    "Remove from new tasks": "Fjern fra nye opgaver",
    "Remove from plan tasks": "Fjern fra planopgaver",
    "Remove": "Fjern",
    "Admin": "Administrator",
    "Remove user": "Fjern bruger",
    "Assign to incomplete tasks": "Tildel til ufuldstændige opgaver",
    "Reassign incomplete tasks": "Tildel ufuldstændige opgaver igen",
    "Assign to plan tasks": "Tildel til planlægning af opgaver",
    "Reassign plan tasks": "Tildel planopgaver igen",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Ejeren tildeles opgaver, hvis den fjernede bruger var den sidst tildelte bruger.",
    "Run integration": "Kør integration",
    "Run": "Kør",
    "Integration configuration": "Integrationskonfiguration",
    "Read the manual": "Læs manualen",
    "Api key": "Api nøgle",
    "Are you sure to delete this integration info?": "Er du sikker på at slette disse integrationsoplysninger?",
    "Edit Contracts": "Ret Kontrakter",
    "Replace following contracts": "Erstat følgende kontrakter",
    "Append services to following contracts": "Tilføjelse af tjenesteydelser til følgende kontrakter",
    "Choose template": "Vælg skabelon",
    "Append only": "Tilføj kun",
    "with template": "med skabelon",
    "All existing contracts": "Alle eksisterende kontrakter",
    "All quarterly contracts": "Alle kvartalsvise kontrakter",
    "All monthly contracts": "Alle månedlige kontrakter",
    "All yearly contracts": "Alle årlige kontrakter",
    "Next invoice number": "Næste fakturanummer",
    "Number is too big, it cannot exceed 15 digits": "Nummeret er for langt, det må ikke overstige 15 cifre",
    "Replace topic": "Udskift emne",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "Alle opgaver og pakker med aktuelt emne vil blive erstattet med det nye valgte emne.",
    "Topics replaced": "Emner udskiftet",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Alle opgaver med emnet “{0}” vil blive erstattet med “{1}”. Dette er ikke reversibelt. Er du sikker?",
    "Name of topic": "Emnets navn",
    "Change topic": "Skift emne",
    "Add new topic": "Tilføj nyt emne",
    "This topic is in use. Do you wish to archive it?": "Dette emne er i brug. Ønsker du at arkivere det?",
    "Are you sure that you want to delete this topic?": "Er du sikker på, at du vil slette dette emne?",
    "These items will be deleted permanently": "Disse elementer slettes permanent",
    "Are you sure that you want to delete this client group?": "Er du sikker på, at du ønsker at slette denne klientgruppe?",
    "This client group is in use. Do you wish to archive it?": "Denne klientgruppe er i brug. Ønsker du at arkivere den?",
    "Edit client group": "Rediger klientgruppe",
    "New client group": "Ny klientgruppe",
    "Price": "Pris",
    "Quantity": "Antal",
    "Unit will be translated to client language": "Enheden vil blive oversat til klientens sprog",
    "Pick date & time": "Vælg dato og klokkeslæt",
    "Share equally": "Del lige meget",
    "Change existing": "Skift eksisterende",
    "Choose bookmark": "Vælg bogmærke",
    "New title": "Ny titel",
    "Set as my default view": "Indstil som min standardvisning",
    "Signature name": "Navn på underskrift",
    "Layout": "Layout",
    "Top": "Top",
    "Middle": "Midt",
    "Bottom": "Bunden",
    "Default signature": "Standard-signatur",
    "Max. dimensions 130 x 130 px": "Maks. dimensioner 130 x 130 px",
    "Logo left": "Logo til venstre",
    "Logo top": "Top med logo",
    "No logo": "Intet logo",
    "Linkedin": "LinkedIn",
    "Facebook": "Facebook",
    "Email signature": "Email signatur",
    "Edit email signature": "Rediger e-mail-signatur",
    "Add email signature": "Tilføj e-mail-signatur",
    "Font color": "Skriftfarve",
    "Actions": "Handlinger",
    "Delete signature": "Slet underskrift",
    "Do you wish to update related contracts and invoices?": "Ønsker du at opdatere relaterede kontrakter og fakturaer?",
    "Update contract templates, active contracts and open invoices.": "Opdater kontraktskabeloner, aktive kontrakter og åbne fakturaer.",
    "The following fields will be updated": "Følgende felter vil blive opdateret",
    "Custom Value": "Brugerdefineret værdi",
    "This product is in use. Do you wish to archive it?": "Dette produkt er i brug. Ønsker du at arkivere det?",
    "Are you sure that you want to delete this product?": "Er du sikker på, at du vil slette dette produkt?",
    "Customize for client": "Tilpas til klient",
    "Customize for template": "Tilpas til skabelon",
    "Open product template": "Åbn produktskabelon",
    "Create product template": "Opret produktskabelon",
    "Master template": "Master skabelon",
    "Client product": "Kundeprodukt",
    "Client product / service": "Kundens produkt/service",
    "New client product": "Nyt kundeprodukt",
    "Template product": "Skabelon produkt",
    "Template product / service": "Skabelon til produkt/service",
    "New template product": "Nyt skabelonprodukt",
    "Edit translations": "Rediger oversættelser",
    "Billable topics": "Fakturerbare emner",
    "Billable time": "Fakturerbar tid",
    "Minimum quantity": "Minimum mængde",
    "Minimum time": "Minimum tid",
    "Integration parameters": "Integrationsparametre",
    "Empty values will use product default": "Tomme værdier vil bruge produktstandard",
    "Pricing": "Priser",
    "DC %": "Rabat %",
    "Sum all matching rows": "Sum alle matchende rækker",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Når den er aktiveret, er den samlede pris en kumulativ sum af alle matchende rækker. Som standard bruger den samlede pris kun den højeste matchende række.",
    "Prices since": "Priser siden",
    "Add price": "Tilføj pris",
    "Add pricing period": "Tilføj prisperiode",
    "Update contracts": "Opdater kontrakter",
    "(Without topic)": "(Uden emne)",
    "Fixed price": "Fast pris",
    "Product": "Produkt",
    "Event created": "Begivenheden oprettet",
    "Project created": "Projekt oprettet",
    "Event deleted": "Begivenheden slettet",
    "Project deleted": "Projekt slettet",
    "Workflow added": "Workflow tilføjet",
    "Workflow removed": "Workflow fjernet",
    "Workflow updated": "Workflow opdateret",
    "Event cancelled": "Aflyst",
    "Project cancelled": "Projekt aflyst",
    "Event reactivated": "Begivenhed genaktiveret",
    "Project reactivated": "Projekt genaktiveret",
    "Event archived": "Begivenhed arkiveret",
    "Project archived": "Projekt arkiveret",
    "Event unarchived": "Begivenhed ikke arkiveret",
    "Project unarchived": "Projektet er ikke arkiveret",
    "Event changed": "Begivenhed ændret",
    "Project changed": "Projektet er ændret",
    "Event status changed: {0}": "Hændelsesstatus ændret: {0}",
    "Project status changed: {0}": "Projektstatus ændret: {0}",
    "Event status changed": "Begivenhedens status er ændret",
    "Project status changed": "Projektets status er ændret",
    "Task created": "Opgave oprettet",
    "Task changed": "Opgave ændret",
    "Task finished": "Opgave afsluttet",
    "Task not finished": "Opgave ikke afsluttet",
    "Task deleted": "Opgave slettet",
    "Add project": "Tilføj projekt",
    "Hide filters": "Skjul filtre",
    "Show filters": "Vis filtre",
    "Cancel event": "Annuller begivenhed",
    "Cancel project": "Annuller projekt",
    "Manage event fields": "Administrer begivenhedsfelter",
    "Manage project fields": "Administrer projektfelter",
    "New event": "Nyt arrangement",
    "New project": "Nyt projekt",
    "{0} (Copy)": "{0} (Kopier)",
    "Are you sure you wish to delete this project?": "Er du sikker på, at du ønsker at slette dette projekt?",
    "Are you sure to archive this event?": "Er du sikker på, at du vil arkivere denne begivenhed?",
    "Are you sure to archive this project?": "Er du sikker på, at du vil arkivere dette projekt?",
    "Are you sure to cancel this event?": "Er du sikker på, at du vil aflyse denne begivenhed?",
    "Are you sure to cancel this project?": "Er du sikker på, at du vil aflyse dette projekt?",
    "Communication": "Kommunikation",
    "Log": "Log",
    "Create event workflow": "Opret arbejdsgang for begivenheder",
    "Create project workflow": "Opret projektarbejdsgang",
    "Use workflow templates to set up tasks effectively or": "Brug workflow-skabeloner til at opsætte opgaver effektivt eller",
    "Add tasks manually": "Tilføj opgaver manuelt",
    "Save bookmark": "Gem bogmærke",
    "Remove filters": "Fjern filtre",
    "Filter": "Filter",
    "Show multiselect": "Vis multiselect",
    "To do today": "To do i dag",
    "This and next month": "Denne og næste måned",
    "Last 3 months": "Sidste 3 måneder",
    "Next 3 months": "De næste 3 måneder",
    "Starts": "Starter",
    "To do": "To do",
    "today": "i dag",
    "tomorrow": "i morgen",
    "yesterday": "i går",
    "Previous week": "Forrige uge",
    "Group similar tasks": "Gruppér lignende opgaver",
    "Group by client": "Gruppér efter klient",
    "Group by date": "Gruppér efter dato",
    "Group by topic": "Gruppér efter emne",
    "Your details": "Dine oplysninger",
    "City": "By",
    "Regional format": "Regionalt format",
    "Default company": "Standardfirma",
    "Lock time entries notification": "Notifikation om låsetidsindgange",
    "Notify by": "Giv besked pr",
    "Delete my account": "Slet min konto",
    "Attention": "Opmærksomhed",
    "Are you sure that you want to delete your account?": "Er du sikker på, at du vil slette din konto?",
    "Notification": "Notifikation",
    "Notification & email": "Notifikation og e-mail",
    "Vacations / absence": "Ferie/fravær",
    "Edit balance": "Rediger saldo",
    "View history": "Vis historie",
    "Request": "Anmodning",
    "How long": "Hvor længe",
    "Requested": "Anmodet",
    "Approved": "Accepteret",
    "Rejected": "Afvist",
    "In review": "Under gennemgang",
    "Change": "Lave om",
    "Agreements": "Aftaler",
    "New agreement": "Ny aftale",
    "Change agreement": "Skift aftale",
    "Stop demo": "Stop demo",
    "Show": "At vise",
    "Don't show": "Vis ikke",
    "Don't send": "Send ikke",
    "Email workdays at 7 AM": "E-mail arbejdsdage kl. 7",
    "Email at 3 PM": "E-mail kl. 15.00",
    "Email at once": "E-mail med det samme",
    "Email Sundays at 11 PM": "E-mail søndage kl. 23.00",
    "First day of the month": "Første dag i måneden",
    "to email": "til e-mail",
    "E-mail at once": "E-mail med det samme",
    "System": "System",
    "Person": "Person",
    "Picture": "Billede",
    "Time zone": "Tidszone",
    "Calendar settings": "Kalenderindstillinger",
    "Public holidays": "Helligdage",
    "Tax deadlines": "Frister for SKAT",
    "News": "Nyheder",
    "External services": "Eksterne tjenester",
    "Google log in": "Log ind med Google",
    "Microsoft log in": "Log ind med Microsoft",
    "Are you sure to remove microsoft?": "Er du sikker på, at du vil fjerne Microsoft-forbindelsen?",
    "Agreement": "Aftale",
    "Active agreement": "Aktiver aftale",
    "Weekly hours": "Ugentlige timer",
    "Are you sure to remove google?": "Er du sikker på, at du vil fjerne Google-forbindelsen?",
    "Edit supplier": "Rediger leverandør",
    "New supplier": "Ny leverandør",
    "Are you sure you wish to delete this supplier?": "Er du sikker på, at du ønsker at slette denne leverandør?",
    "Add supplier": "Tilføj leverandør",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Leverandørtyper er ikke defineret. Gå til indstillingerne i appen for leverandører for at tilføje dem.",
    "No members yet": "Ingen medlemmer endnu",
    "Edit group": "Rediger gruppe",
    "Add group": "Tilføj gruppe",
    "Are you sure to delete this user group?": "Er du sikker på, at du vil slette denne brugergruppe?",
    "Get set up to work with team": "Bliv klar til at arbejde med teamet",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Virksomhedskonto giver dig mulighed for at bruge værktøjer til teams, få dybere indsigt osv. Hæv kvaliteten af dit teams workflow og før en mere rentabel forretning.",
    "Create company account": "Opret virksomhedskonto",
    "By creating a company account you activate Uku free subscription for {0} days.": "Ved at oprette en virksomhedskonto aktiverer du et gratis abonnement på Uku i {0} dage.",
    "You have invited {0}/{1} members": "Du har inviteret {0}/{1} medlemmer",
    "Upgrade": "Opgrader",
    "Resend invite": "Send invitation igen",
    "Send invite": "Send invitation",
    "View profile": "Vis profil",
    "To add members to your team, you'll need to create a company account": "Hvis du vil tilføje medlemmer til dit team, skal du oprette en virksomhedskonto",
    "Export": "Eksport",
    "Re-invite sent": "Geninvitation sendt",
    "View report": "Se rapport",
    "Member {0} will be deactivated.": "Medlem {0} vil blive deaktiveret.",
    "Please select new member who will replace {0}.": "Vælg venligst et nyt medlem, der skal erstatte {0}.",
    "Select new member": "Vælg nyt medlem",
    "NB! Deactivation process cannot be reversed": "NB! Deaktiveringsprocessen kan ikke fortrydes",
    "Magic button settings": "Indstillinger for den magiske knap",
    "Create only one task per month": "Opret kun én opgave pr. måned",
    "Current month's tasks": "Nuværende måneds opgaver",
    "extra work": "ekstra arbejde",
    "Without topic": "Uden emne",
    "Week": "Uge",
    "Previous month": "Forrige måned",
    "task | tasks": "opgave | opgaver",
    "Assign to": "Tildel til",
    "Mark as done": "Marker som færdig",
    "Last": "Sidst",
    "Snooze": "Snooze",
    "1 dependency": "1 afhængighed",
    "{0} dependencies": "{0} afhængigheder",
    "Client request": "Kundeanmodning",
    "Unread notification emails": "Ulæste notifikationsmails",
    "Unread internal comments": "Ulæste interne kommentarer",
    "Add comment": "Tilføj kommentar",
    "Internal comment": "Intern kommentar",
    "Portal message": "Portal besked",
    "Public message means that clients can read it and the client portal will notify them by email": "Portal besked betyder, at klienter kan læse den, og klientportalen giver dem besked via e-mail",
    "Type a comment": "Skriv en kommentar",
    "Send portal message": "Send portalbesked",
    "Open timesheet": "Åbn timeseddel",
    "Pause timer": "Pause timer",
    "Mark undone": "Marker uafsluttet",
    "Digitise": "Digitaliser",
    "Documents sent to digitisation": "Dokumenter sendt til digitalisering",
    "Followers": "Følgere",
    "Start / Due date": "Start / slut dato",
    "Select topic": "Vælg emne",
    "1 document": "1 dokument",
    "{0} documents": "{0} dokumenter",
    "Download": "Download",
    "Download all": "Download alle",
    "Assign as task": "Tildel som opgave",
    "When selected, the task is sent as a task to the client": "Når valgt, sendes opgaven som en opgave til klienten",
    "Auto finish": "Automatisk færdiggørelse",
    "When selected, the task is marked done after client finishes it": "Når valgt, markeres opgaven som udført, når klienten er færdig med den",
    "Add comment / message": "Tilføj kommentar/besked",
    "Add email": "Tilføj e-mail",
    "Add estimation": "Tilføj estimering",
    "Add task field": "Tilføj opgavefelt",
    "Add dependency": "Tilføj afhængighed",
    "Drop files to upload": "Slip filer for at uploade",
    "Task sent to client portal": "Opgave sendt til kundeportal",
    "Task no longer assigned to client portal": "Opgaven er ikke længere tildelt klientportalen",
    "Save recurring task": "Gem tilbagevendende opgave",
    "Add to-do list": "Tilføj to-do-liste",
    "Waiting for event status: {0}": "Venter på hændelsesstatus: {0}",
    "Waiting for project status: {0}": "Venter på projektstatus: {0}",
    "Edit template task": "Rediger skabelonopgave",
    "Create recurring task": "Opret tilbagevendende opgave",
    "Make a copy": "Lav en kopi",
    "Add topic": "Tilføj emne",
    "Delete task": "Slet opgave",
    "Delete task template": "Slet opgaveskabelon",
    "Select task field": "Vælg opgavefelt",
    "No custom fields available for this client": "Ingen tilpassede felter tilgængelige for denne klient",
    "task": "opgave",
    "recurring task": "tilbagevendende opgave",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Har du til hensigt at fjerne dig selv fra {0}, eller vil du slette det helt?",
    "This {1} is shared with {0}": "Denne {1} deles med {0}",
    "Remove only me": "Fjern kun mig",
    "Time has been tracked to this task.": "Der er registreret tid til denne opgave.",
    "Are you sure to delete this task?": "Er du sikker på, at du vil slette denne opgave?",
    "Undefined": "Udefineret",
    "COPY": "KOPI",
    "On task due date": "På opgavens forfaldsdato",
    "{0} day before": "{0} dag før",
    "{0} days before": "{0} dage før",
    "Edit workflow": "Rediger workflow",
    "Duplicate project": "Dupliker projekt",
    "Reset layout": "Nulstil layout",
    "Any time": "Når som helst",
    "Assign user...": "Tildel bruger ...",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 time",
    "Add notes": "Tilføj noter",
    "Task start date": "Opgavens startdato",
    "Task due date": "Opgavens forfaldsdato",
    "Recurrence task": "Gentagende opgave",
    "Search from one time templates": "Søg fra engangsskabeloner",
    "Placeholders": "Pladsholdere",
    "New task": "Ny opgave",
    "New recurring task": "Ny tilbagevendende opgave",
    "+1 day": "+1 dag",
    "Edit comment": "Rediger kommentar",
    "Timer is running!": "Timeren kører!",
    "Continue time from {0}": "Fortsæt tid fra {0}",
    "New time entry": "Ny tidsregistrering",
    "Load more": "Indlæs mere",
    "Are you sure to delete this time entry?": "Er du sikker på at slette denne tidsindgang?",
    "Save automated email": "Gem automatiseret e-mail",
    "Automation": "Automatisering",
    "Are you sure to delete this email?": "Er du sikker på, at du vil slette denne e-mail?",
    "Are you sure you wish to send this email immediately?": "Er du sikker på, at du ønsker at sende denne e-mail med det samme?",
    "replied to project email": "svarede på projektets e-mail",
    "replied to client email": "svarede på kundens e-mail",
    "commented": "kommenterede",
    "Reply": "Svar",
    "Are you sure to delete this comment?": "Er du sikker på at slette denne kommentar?",
    "replied to client portal email": "svarede på klientportalens e-mail",
    "sent a message": "sendt en besked",
    "replied to task email": "svarede på opgave-e-mail",
    "failed to send": "kunne ikke sende",
    "sent email": "e-mail sendt",
    "no one": "ingen",
    "created this task.": "oprettede denne opgave.",
    "Task was automatically created from forwarded e-mail": "Opgaven blev automatisk oprettet fra en videresendt e-mail",
    "Task was automatically created from client portal e-mail": "Opgaven blev automatisk oprettet fra klientportalens e-mail",
    "Task was automatically created from client e-mail": "Opgaven blev automatisk oprettet fra klientens e-mail",
    "Task was automatically created from project e-mail": "Opgaven blev automatisk oprettet fra projektets e-mail",
    "requested assistance.": "bad om hjælp.",
    "updated this task.": "opdaterede denne opgave.",
    "tracked time to this task.": "sporet tid til denne opgave.",
    "finished this task.": "afsluttet denne opgave.",
    "new comment.": "ny kommentar.",
    "reassigned this task.": "omplacerede denne opgave.",
    "assigned the task to {0}.": "tildelte opgaven til {0}.",
    "reminder.": "påmindelse.",
    "deleted.": "slettet.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "afsluttede opgaven, men Uku fuldførte ikke denne opgave automatisk, fordi ikke alle opgavekrav var opfyldt.",
    "sent task to client portal": "sendt opgave til kundeportal",
    "assigned the task to client.": "overdraget opgaven til klienten.",
    "assigned the task to company.": "overdraget opgaven til virksomheden.",
    "added attachment(s).": "tilføjede vedhæftede filer.",
    "added a comment.": "ilføjet en kommentar.",
    "added a message to {0}.": "tilføjede en besked til {0}.",
    "received a e-mail from {0}.": "modtog en e-mail fra {0}.",
    "updated notes.": "opdaterede noter.",
    "made changes to checklist.": "foretaget ændringer i tjeklisten.",
    "created this task template.": "oprettede denne opgaveskabelon.",
    "updated this task template.": "opdaterede denne opgaveskabelon.",
    "recurring task assigned.": "tilbagevendende opgave tildelt.",
    "recurring task deleted.": "tilbagevendende opgave slettet.",
    "added email.": "tilføjet e-mail.",
    "changed email.": "ændret e-mail.",
    "deleted email.": "slettet e-mail.",
    "sent email.": "sendt e-mail.",
    "failed to send.": "afsendelse mislykkedes.",
    "added email": "tilføjet e-mail",
    "changed email": "ændret e-mail",
    "deleted email": "slettet e-mail",
    "Member / Time": "Medlem / Tid",
    "Client/topic": "Klient/emne",
    "Client/task": "Klient/opgave",
    "Client/member": "Klient/medlem",
    "Member/topic": "Medlem/emne",
    "Member/task": "Medlem/opgave",
    "Member/client": "Medlem/klient",
    "Member/date": "Medlem/dato",
    "Date/member": "Dato/medlem",
    "Grouped": "Grupperet",
    "Client/project": "Kunde/projekt",
    "Project/member": "Projekt/medlem",
    "Period balance": "Periode balance",
    "Reset balance": "Nulstil balancen",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Tidsangivelsen er blevet bekræftet, eller varigheden er blevet ændret, og varigheden opdateres ikke dynamisk",
    "(Without project)": "(Uden projekt)",
    "Decline": "Afvist",
    "Accept": "Accept",
    "Cancel decision": "Annuller beslutning",
    "Accepted": "Accepteret",
    "Declined": "Afvist",
    "Report data has changed. Please update report.": "Rapportdata er ændret. Opdater venligst rapporten.",
    "Agreed": "Aftalt",
    "Non billable": "Ikke fakturerbar",
    "Export report to Excel": "Eksporter rapport til Excel",
    "By default, we export the result of the selected filters with the columns of the configured table": "Som standard eksporterer vi resultatet af de valgte filtre med kolonnerne i den konfigurerede tabel",
    "Add to export client custom fields": "Tilføj for at eksportere brugerdefinerede kundefelter",
    "Save report": "Gem rapport",
    "Export PDF": "Eksporter PDF",
    "Export Excel": "Eksporter Excel",
    "We have new version of": "Vi har en ny version af",
    "Log out": "Log ud",
    "Previous day": "Forrige dag",
    "Next day": "Næste dag",
    "Mark all as read": "Markér alle som læst",
    "Search task/client": "Søg opgave/klient",
    "from client portal": "fra klientportalen",
    "Hide all": "Skjul alle",
    "Hide for 1 hour": "Gem dig i 1 time",
    "Something went wrong": "Noget gik galt",
    "User authentication needed": "Brugergodkendelse nødvendig",
    "Invalid rights": "Ugyldige rettigheder",
    "The object cannot be found": "Objektet kan ikke findes",
    "Content too large": "Indhold for stort",
    "An unknown error occurred": "Der opstod en ukendt fejl",
    "The action requested cannot be performed": "Den ønskede handling kan ikke udføres",
    "Go": "Kør",
    "Actual / monitoring (month)": "Faktisk/overvågning (måned)",
    "h": "h",
    "Actual": "Faktiske",
    "Month": "Måned",
    "I’m setting up your account": "Jeg opretter din konto",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Vidste du, at regnskabsfirmaer, der er begyndt at bruge Uku, kan betjene 38 % flere kunder på samme tid.",
    "Let’s setup your company": "Lad os oprette din virksomhed",
    "Name of your company": "Navn på din virksomhed",
    "Size of your team?": "Størrelse på dit team?",
    "Which software are you using?": "Hvilken software bruger du?",
    "This knowledge will help us to improve Uku": "Denne viden hjælper os med at forbedre Uku",
    "What other software needs to be integrated?": "Hvilken anden software skal integreres?",
    "Book a demo": "Book en demo",
    "Hi {0},": "Hej {0},",
    "NO BOTS - ONLY HUMANS": "INGEN BOTS - KUN MENNESKER",
    "Start a 14 day free trial": "Start en 14 dages gratis prøveperiode",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "“Uku er en utrolig funktionel software. Uku har boostet vores arbejdsstyring og hjælper os med at yde en enestående service.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Den hurtigste måde, hvorpå du kan afgøre, om Uku kan være til gavn for {0}, er et kort opkald på {1} minutter med vores onboarding-specialist.",
    "Hi, I'm Uku ": "Hej, jeg er Uku ",
    "I help to set up your account.": "Jeg hjælper med at oprette din konto.",
    "It only takes a minute.": "Det tager kun et minut.",
    "Choose": "Vælge",
    "Your country": "Dit land",
    "Your language": "Vælg sprog",
    "Begin": "Begynde",
    "Let’s become friends": "Lad os blive venner",
    "Your first name": "Dit fornavn",
    "What is your field of work?": "Hvad er dit arbejdsområde?",
    "Your field of work": "Dit arbejdsområde",
    "How will you use Uku?": "Hvordan vil du bruge Uku?",
    "How did you hear about Uku?": "Hvordan har du hørt om Uku?",
    "Choose channel": "Vælg kanal",
    "Please specify how you heard about us": "Angiv venligst, hvordan du hørte om os",
    "Let me know Uku's new features by email": "Lad mig kende Ukus nye funktioner via e-mail",
    "Finish": "Afslut",
    "First name is required": "Fornavn er påkrævet",
    "Name is required": "Navn er påkrævet",
    "Team size is required": "Teamstørrelse er påkrævet",
    "Surname is required": "Efternavn er påkrævet",
    "Field is required": "Feltet er påkrævet",
    "I will use Uku to work together with two or more teammates.": "Jeg vil bruge Uku til at arbejde sammen med to eller flere holdkammerater.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Jeg vil bruge Uku alene. Denne version er gratis, men funktionerne er begrænsede.",
    "Media": "Medie",
    "Through integration partner": "Gennem integrationspartner",
    "Referral by friend": "Henvisning fra en ven",
    "Import speeds up your clients setup, smart choice!": "Importering fremskynder opsætningen af dine kunder, smart valg!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Sidste import: tilføjede {0}, opdaterede {1}, sprang {2} over, undlod at importere {3} klient",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Sidste import: tilføjede {0}, opdaterede {1}, sprang {2} over, undlod at importere {3} klienter",
    "Last import: added {0}, updated {1}, skipped {2}": "Sidste import: tilføjede {0}, opdaterede {1}, sprang {2} over",
    "What's next? Correct the data of {0} clients and upload again.": "Hvad er det næste? Korriger dataene for {0} klienter og upload igen.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX) ",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "I stedet for at indtaste kunderne en efter en kan du benytte filimport til en stor kundebase.",
    "Import all Merit Aktiva clients and keep client data automatically updated": "Importer alle Merit Aktiva klienter og hold klientdata automatisk opdateret",
    "Ignore": "Ignorer",
    "NEW CLIENT": "NY KLIENT",
    "Preview": "Eksempel",
    "Import started": "Importering påbegyndt",
    "Only new clients": "Kun nye klienter",
    "Update data from company register": "Opdatering af data fra virksomhedsregisteret",
    "If switched on, the company data is updated using the local business register": "Hvis slået til, opdateres virksomhedsdataene ved hjælp af det lokale virksomhedsregister",
    "We did not find a match in Äriregister": "Vi fandt ikke et match i Äriregister",
    "We did not find a match in Companies House": "Vi fandt ikke noget match i Companies House",
    "No integration yet": "Ingen integration endnu",
    "Uku match": "Uku-ækvivalent",
    "Business register nr.": "Virksomhedsregister nr.",
    "Company register": "Virksomhedsregister",
    "Upload file": "Upload fil",
    "Before uploading your file": "Før du uploader din fil",
    "Learn Uku’s data structure": "Lær Uku's datastruktur",
    "Download and use our sample file to see exactly how we organize data in Uku": "Download og brug vores prøvefil for at se præcis, hvordan vi organiserer data i Uku",
    "Download Client Import Example": "Download eksempel på klientimport",
    "Download Contact Import Example": "Download eksempel på kontaktimport",
    "Fill in fields": "Udfyld felter",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Det eneste obligatoriske felt er virksomhedens navn. Sørg for, at du har udfyldt alle de nødvendige felter, inden du uploader filen.",
    "Learn more about mandatory fields": "Få mere at vide om obligatoriske felter",
    "Create custom fields": "Opret brugerdefinerede felter",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Nogle datafelter er muligvis ikke med som standard. Sørg for at oprette disse brugerdefinerede felter, inden du importerer dine data.",
    "Add new custom fields": "Tilføj nye tilpassede felter",
    "...or drag a file here": "...eller træk en fil hertil",
    "Only Excel (.xls, .xlsx) file types are supported": "Kun Excel (.xls, .xlsx) filtyper understøttes",
    "Mapping": "Mapping",
    "First row is a header": "Første række er en overskrift",
    "Add field to all clients": "Tilføj felt til alle klienter",
    "Add client group": "Tilføj klientgruppe",
    "Fields for all clients": "Felter for alle kunder",
    "Import of {0} in progress": "Import af {0} i gang",
    "Import in progress": "Import i gang",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Det kan tage noget tid. Du kan lave andre aktiviteter i Uku på samme tid, vi giver dig besked, når den er klar.",
    "Cancel import": "Annuller import",
    "Are you sure you want to cancel import?": "Er du sikker på, at du vil annullere importen?",
    "Last updated": "Sidst opdateret",
    "Contracts": "Kontrakter",
    "Job name": "Jobnavn",
    "Workflow name": "Navn på workflow",
    "Details": "Detaljer",
    "Select jobs": "Vælg job",
    "Select task plan": "Vælg opgaveplan",
    "of existing client": "af eksisterende klient",
    "You can also choose": "Du kan også vælge",
    "existing client tasks plan": "eksisterende klientopgaveplan",
    "existing predefined jobs": "eksisterende foruddefinerede job",
    "create a new plan": "opret en ny plan",
    "Select workflow": "Vælg workflow",
    "existing project workflow": "eksisterende projektworkflows",
    "existing workflow": "eksisterende workflow",
    "create a new workflow": "opret et nyt workflow",
    "New tasks template": "Ny opgaver skabelon",
    "to save template!": "gem skabelon!",
    "You can also add tasks from jobs": "Du kan også tilføje opgaver fra forskellige jobs",
    "or choose": "eller vælg",
    "New workflow template": "Ny skabelon for workflow",
    "You can also add tasks from existing workflow templates": "Du kan også tilføje opgaver fra eksisterende workflow skabeloner",
    "existing event workflow": "eksisterende event-workflow",
    "Hide others": "Skjul andre",
    "Update all events (New tasks)": "Opdater alle begivenheder (nye opgaver)",
    "Update all projects (New tasks)": "Opdater alle projekter (nye opgaver)",
    "Once": "Enkelt gang",
    "Once a month": "En gang om måneden",
    "Once a quarter": "En gang i kvartalet",
    "Once a year": "En gang om året",
    "Company workflow": "Virksomhedens workflow",
    "Company jobs": "Virksomhedsjobs",
    "Default jobs": "Standardjob",
    "ID": "ID",
    "Task title and labels": "Opgave titel og etiketter",
    "Assigned and time": "Tildelt og tid",
    "Setup tasks for {0} event": "Opsætningsopgaver for {0}-begivenhed",
    "Setup tasks for {0} project": "Opsætning af opgaver for {0}-projektet",
    "New job": "Nyt job",
    "Edit job": "Rediger job",
    "New workflow": "Nyt workflow",
    "Save workflow": "Gem workflow",
    "Create task plan": "Opret opgaveplan",
    "Confirm task plan": "Bekræft opgaveplan",
    "Skip": "Spring over",
    "Confirm workflow": "Bekræft workflow",
    "Client portal templates": "Kundeportal skabeloner",
    "Jobs": "Jobs",
    "Workflows": "Workflow",
    "Company workflows": "Virksomhedens arbejdsgange",
    "Default workflows": "Standard arbejdsgange",
    "Company template saved": "Virksomhedsskabelon gemt",
    "Company template created": "Virksomhedsskabelon oprettet",
    "Format": "Format",
    "Currency": "Valuta",
    "Reference number": "Referencenummer",
    "Invoice description": "Faktura beskrivelse",
    "Summarize invoice rows": "Opsummer fakturarækker",
    "Summarized description": "Sammenfattende beskrivelse",
    "Reverse charge": "Omvendt opladning",
    "Rounding": "Afrunding",
    "Time rounding will apply for each line": "Tiden afrundes for hver linje",
    "Rounding increment (up)": "Afrund stigninger (op)",
    "Reply to": "Svar til",
    "Configuration": "Konfiguration",
    "Invoice to parent company": "Faktura til moderselskab",
    "Create all invoices under parent company.": "Opret alle fakturaer under moderselskabet.",
    "User code": "Brugerkode",
    "Default": "Standard",
    "Default value will apply for each line": "Standardværdien gælder for hver linje",
    "Number": "Nummer",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Du kan skrive et af følgende i parenteser til at fakturere præfiksfeltet. Når du gemmer kontrakten, udfyldes præfikset med den tilsvarende værdi.",
    "Copy to clipboard": "Kopier til udklipsholder",
    "Invoice previous period": "Fakturer forrige periode",
    "Invoice period": "Faktureringsperiode",
    "Invoice next period": "Fakturer næste periode",
    "Client primary user": "Klientens primære bruger",
    "Original client name": "Oprindeligt klientnavn",
    "invoice date year": "fakturadato år",
    "last two digits of invoice date year": "de sidste to cifre i fakturadato år",
    "invoice date month": "fakturadato måned",
    "invoice date day": "fakturadato dag",
    "Copied to clipboard": "Kopieret til udklipsholderen",
    "Contract": "Kontrakt",
    "Net total": "Netto i alt",
    "Contract #": "Kontrakt #",
    "Invoice #": "Faktura #",
    "Exported": "Eksporteret",
    "Sent": "Sendt",
    "Net": "Netto",
    "Add invoice": "Tilføj faktura",
    "Change invoice number": "Skift fakturanummer",
    "Review changes": "Gennemgå ændringer",
    "Please review and approve changes to the related events": "Gennemgå og godkend ændringer til de relaterede begivenheder",
    "Please review and approve changes to the related projects": "Gennemgå og godkend ændringer til de relaterede projekter",
    "Contains": "Indeholder",
    "contains": "indeholder",
    "Exactly": "Præcis",
    "is exactly": "er præcis",
    "Greater than": "Større end",
    "is greater than": "er større end",
    "Less than": "Mindre end",
    "is less than": "er mindre end",
    "Range": "Område",
    "is in range of": "ligger inden for",
    "is empty": "er tom",
    "Task plan": "Opgaveplan",
    "Edit plan": "Rediger plan",
    "Use task plan templates to set up tasks effectively or add a task manually": "Brug opgaveplanskabeloner til at opsætte opgaver effektivt, eller tilføj en opgave manuelt",
    "Add task manually": "Tilføj opgave manuelt",
    "Quarterly": "Kvartalsvis",
    "Export excel": "Eksporter excel",
    "Print PDF": "Udskriv PDF",
    "Edit jobs": "Rediger job",
    "Replace plan tasks with job": "Udskift planopgaver med job",
    "Select template": "Vælg skabelon",
    "member": "medlem",
    "Tasks with user will be added to every selected client": "Opgaver med brugeren føjes til hver valgte klient",
    "Add even if job already applied": "Tilføj, selvom jobbet allerede er søgt",
    "Default user": "Standardbruger",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Dette sletter alle opgaver fra klientplanen og lægger kun den valgte skabelons opgaver ind i den",
    "Adding template will be ready in a minute. You can continue with work.": "Tilføjelse af skabelon vil være klar om et minut. Du kan fortsætte med arbejdet.",
    "Add client": "Tilføj klient",
    "Export clients": "Eksporter klienter",
    "Export client contacts": "Eksporter kundekontakter",
    "client | clients": "klient | klienter",
    "clients": "klienter",
    "client(s) had errors": "klient(er) havde fejl",
    "client(s) selected": "klient(er) valgt",
    "Contract actions": "Kontrakt handlinger",
    "Edit Members": "Rediger Medlemmer",
    "Edit monitoring": "Rediger overvågning",
    "Your company": "Dit selskab",
    "Edit billing": "Rediger fakturering",
    "Activate client portal": "Aktiver klientportal",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Efter aktivering kan du sende opgaver direkte til alle klientens kontakter, som har en e-mailadresse.",
    "Send welcome invitation to client contacts": "Send en velkomstinvitation til kundekontakter",
    "Who will receive an invitation?": "Hvem modtager en invitation?",
    "Client contact who has one valid e-mail address": "Kundekontakt, som har én gyldig e-mailadresse",
    "Client contact who has the client's portal open (default for all)": "Kundekontakt, der har kundens portal åben (standard for alle)",
    "How does the invitation work?": "Hvordan fungerer invitationen?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku opretter og sender en \"velkomstopgave\" til hver kundekontakt. Den oprettes af kundens primære bruger baseret på opgaveskabelonen 'Velkommen til kundeportalen'. Se den under din virksomheds opgaveskabeloner. Den vil blive oversat i henhold til kontaktens sprog.",
    "Uku client portal always informs clients by email about new tasks.": "Uku-klientportal informerer altid kunder via e-mail om nye opgaver.",
    "View templates": "Se skabeloner",
    "Client portal activated": "Klientportal aktiveret",
    "Company's name": "Virksomhedens navn",
    "Mark": "Markér",
    "Add members": "Tilføj medlemmer",
    "Members and groups": "Medlemmer og grupper",
    "Topic is required": "Emne er påkrævet",
    "Entering time is required": "Indtastningstid kræves",
    "Delete client": "Slet klient",
    "Manage client fields": "Administrer klientfelter",
    "Max 3 characters": "Maks. 3 tegn",
    "Are you sure you wish to delete this client?": "Er du sikker på, at du vil slette denne klient?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "Sletning af klientdata vil også slette alle klientrelaterede opgaver.<br/><br/>NB! Klientens historik vil blive slettet",
    "Owner": "Ejer",
    "All clients that you add under {0} will be deleted later.</div>": "Alle kunder, som du tilføjer under {0}, <span class='error—text font-weight-medium'>vil blive slettet</span> senere.</div>",
    "Use this account for testing purposes only!": "Brug kun denne konto til testformål!",
    "Read more about the demo account": "Læs mere om demokontoen",
    "Rights": "Rettigheder",
    "Monitoring setup": "Overvågningsopsætning",
    "Learn more about monitoring": "Lær mere om overvågning",
    "selected": "valgte",
    "Invoicing": "Fakturering",
    "Billing template": "Faktureringsskabelon",
    "New": "Ny",
    "Add row": "Tilføj række",
    "Delete contract": "Slet kontrakt",
    "Product / description": "Produkt / beskrivelse",
    "Qty": "Antal",
    "Product placeholders": "Produktpladsholdere",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "Du kan skrive en hvilken som helst af følgende linjer i krøllede parenteser til produktbeskrivelsen. Når du gemmer en faktura, vil den erstatte teksten med den tilsvarende værdi.",
    "Template saved": "Skabelon gemt",
    "Warning": "Advarsel",
    "Would you like to apply these changes to all clients using this contract template?": "Ønsker du at anvende disse ændringer for alle kunder, der bruger denne kontraktskabelon?",
    "Yes, apply to all clients": "Ja, tilføj for alle kunder",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Du har foretaget ændringer i den tidsperiode, som denne faktureringskontrakt gælder for. Dette kan ændre, hvordan berørte ikke-fakturerede tjenester i fortiden og fremtiden faktureres. Bekræft venligst, at denne ændring var forsætlig.",
    "Are you sure to delete this template?": "Er du sikker på, at du vil slette denne skabelon?",
    "Save template": "Gem skabelon",
    "Save as template": "Gem som skabelon",
    "Please note all changes made to contract will be lost": "Bemærk venligst, at alle ændringer i kontrakten vil gå tabt",
    "Add contract": "Tilføj kontrakt",
    "Manage contract templates": "Administrer kontraktskabeloner",
    "Change account details": "Skift kontooplysninger",
    "Country is required": "Land kræves",
    "Address": "Adresse",
    "Postal code": "Postnummer",
    "State": "Stat",
    "Uku is set up according to the field of work.": "Uku er opsat i henhold til arbejdsområdet.",
    "Size of the team": "Holdets størrelse",
    "Website": "Hjemmeside",
    "Delete account": "Slet konto",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Sletning af en konto sletter også alle klienter, der er tilknyttet kontoen, deres opgaver og hele deres historie. Er du sikker på, at du vil slette din konto?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Ja, slet kontoen med alle relaterede data såsom klienter, opgaver og al historik",
    "These invoices cannot be sent. Check their status or error messages.": "Disse fakturaer kan ikke sendes. Tjek deres status eller fejlmeddelelser.",
    "Please confirm that you wish to proceed.": "Bekræft venligst, at du vil fortsætte.",
    "Sending invoice | Sending invoices": "Afsendelse af faktura | Afsendelse af fakturaer",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Du er ved at sende denne faktura til kunden. | Du er ved at sende disse fakturaer til kunder.",
    "Error in calculating invoice": "Fejl ved beregning",
    "Error in importing invoice": "Fejl ved import af faktura",
    "Error in creating invoice": "Fejl ved oprettelse af faktura",
    "Error in exporting invoice": "Fejl ved eksport af faktura",
    "Error in sending invoice": "Fejl ved afsendelse af faktura",
    "Calculating invoice": "Beregning af faktura",
    "Creating invoice": "Oprettelse af faktura",
    "Exporting invoice": "Eksport af faktura",
    "Importing invoice": "Import af faktura",
    "Sending invoice": "Afsendelse af faktura",
    "Clear errors": "Ryd fejl",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Relateret arbejde faktureres igen. Fakturaerne slettes ikke fra eksterne systemer, det skal du gøre manuelt.",
    "Delete invoice | Deleting invoices": "Slet faktura | Slet af fakturaer",
    "Selected net total": "Udvalgt netto i alt",
    "Nothing in invoices": "Intet i fakturaer",
    "Please make sure you have setup recurring billing for your clients": "Sørg for, at du har konfigureret tilbagevendende fakturering til dine kunder",
    "Draft": "Udkast",
    "Approval": "Godkendelse",
    "Created": "Oprettet",
    "Coming soon": "Kommer snart",
    "Selected invoices and related product info will be sent to accounting system.": "Valgte fakturaer og relaterede produktoplysninger sendes til regnskabssystemet.",
    "Piece": "Stykke",
    "Hour": "Time",
    "Delete row": "Slet række",
    "Out of ": "Ud af ",
    " can be created": " kan oprettes",
    "For ": "Til ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " faktureringsperioden er stadig i gang. Alt arbejde, der udføres i denne periode efter oprettelse af fakturaen, faktureres ikke.",
    "Invoice date will be set to today.": "Fakturadato vil blive sat til i dag.",
    "Uku is about to create": "Uku er ved at skabe",
    " selected row, only | selected row, only ": " valgt række kun | valgt række kun ",
    " invoice | invoices": " faktura | fakturaer",
    "These invoices cannot be exported. Check their status or error messages.": "Disse fakturaer kan ikke eksporteres. Tjek deres status eller fejlmeddelelser.",
    "Exporting invoice | Exporting invoices": "Eksport af faktura | Eksport af fakturaer",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Du er ved at eksportere denne faktura til regnskabssoftware. | Du er ved at eksportere disse fakturaer til regnskabssoftware.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "Denne faktura er allerede blevet eksporteret. Er du sikker på, at du vil eksportere den som en ny faktura? | Nogle af disse fakturaer er allerede blevet eksporteret. Er du sikker på, at du vil eksportere dem som nye fakturaer?",
    "Download pdf": "Download pdf",
    "Create invoice": "Opret faktura",
    "Update status from {0}": "Opdater status fra {0}",
    "Show all lines": "Vis alle linjer",
    "Calculate invoice": "Beregn faktura",
    "Loading invoice...": "Indlæser faktura...",
    "Invalid Scoro credentials": "Ugyldige Scoro-legitimationsoplysninger",
    "Please confirm the changes you have made to this invoice.": "Bekræft de ændringer, du har foretaget på denne faktura.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Bemærk, at ændret faktura ikke automatisk sendes til kunden eller eksporteres til eksterne systemer - du bliver nødt til at gøre dette manuelt.",
    "Invoice number already exists! Please confirm to save anyway.": "Fakturanummeret findes allerede! Bekræft venligst at du vil gemme alligevel.",
    "Error in data": "Fejl i data",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Faktureringsperioden er stadig i gang. Alt arbejde, der udføres i denne periode efter oprettelse af fakturaen, faktureres ikke.",
    "Creation date": "Oprettelsesdato",
    "{0} days after": "{0} dage efter",
    "{0} day after": "{0} dag efter",
    "right away when": "med det samme, når",
    "start date": "startdato",
    "due date": "udløbsdato",
    "finished": "afsluttet",
    "Entries count": "Indlæg tæller",
    "Entries excluding sales": "Posteringer ekskl. Salg",
    "Entries excluding bank": "Angivelser eksklusive bank",
    "Entries excluding documents": "Indlæg eksklusive dokumenter",
    "Documents (sales and purchases)": "Dokumenter (salg og køb)",
    "Cash entries": "Kontante poster",
    "VAT entries": "Momsindtastninger",
    "Stock entries": "Lagerposteringer",
    "Sale entries": "Salgsposter",
    "Purchase entries": "Køb poster",
    "Bank entries": "Bankposter",
    "Ledger entries": "Hovedbogsposter",
    "Depreciation entries": "Afskrivninger",
    "Entry lines count": "Antal linjer til indtastning",
    "Company owner": "Virksomhedsejer",
    "Activity": "Aktivitet",
    "Oldest first": "Ældste først",
    "Newest first": "Nyeste først",
    "Quantity as time": "Mængde i tid",
    "Quantity as number": "Mængde som tal",
    "Quantity as time in number format": "Mængde som tid i talformat",
    "No rounding": "Ingen afrunding",
    "min": "min",
    "hour": "time",
    "Last day of month": "Sidste dag i måneden",
    "Invoice line": "Fakturalinje",
    "Task time total (per member)": "Opgavetid i alt (pr. medlem)",
    "Time entry": "Indtastning af tid",
    "Task finish date": "Dato for afslutning af opgaven",
    "Create separately": "Opret separat",
    "Merge into one": "Smelt sammen til én",
    "No minimum": "Intet minimum",
    "{0} minute": "{0} minut",
    "{0} minutes": "{0} minutter",
    "{0} hour": "{0} time",
    "{0} hours": "{0} timer",
    "English": "Engelsk",
    "Estonian": "Estisk",
    "Danish": "Dansk",
    "Lithuanian": "Litauisk",
    "Russian": "Russisk",
    "Finnish": "Finsk",
    "Swedish": "Svensk",
    "Norwegian": "Norsk",
    "Latvian": "Lettisk",
    "Bulgarian": "Bulgarien",
    "German": "Tysk",
    "Spanish": "Spansk",
    "Polish": "Polsk",
    "Field: ": "Felt: ",
    "Normal hours": "Normale timer",
    "Year": "År",
    "Estonia": "Estland",
    "Finland": "Finland",
    "Poland": "Polen",
    "Connection successful!": "Forbindelsen lykkedes!",
    "User": "Bruger",
    "None": "Ingen",
    "Error!": "Fejl!",
    "Pending": "Afventer",
    "Finished": "Færdiggjort",
    "Text": "Tekst",
    "Choice": "Valg",
    "Yes/No": "Ja/Nej",
    "Integer": "Heltal",
    "Multiple choice": "Flere valg",
    "URL": "URL",
    "Multiple users": "Flere brugere",
    "Multiline text": "Tekst på flere linjer",
    "Must be a integer": "Skal være et heltal",
    "Must be a date": "Skal være en dato",
    "Must be a valid e-mail address": "Skal være en gyldig e-mail-adresse",
    "Unknown choice": "Ukendt valg",
    "Some errors occurred:": "Nogen fejl opstod:",
    "Unknown network error": "Ukendt netværksfejl",
    "Could not connect to the service": "Kunne ikke oprette forbindelse til tjenesten",
    "Reload this page": "Genindlæs denne side",
    "Invoice paid": "Faktura betalt",
    "Annulled": "Annulleret",
    "Processing": "Forarbejdning",
    "You are about to deactivate this app.": "Du er ved at deaktivere denne app.",
    "You are about to disconnect this app.": "Du er ved at afbryde forbindelsen til denne app.",
    "Do you also want to activate billing to get the most out of Uku?": "Ønsker du også at aktivere fakturering for at få mest muligt ud af Uku?",
    "Invoice": "Faktura",
    "Clients - Monitoring": "Klienter - Oversigt",
    "Links": "Links",
    "New template": "Ny skabelon",
    "Import Clients from Excel": "Importer klienter fra Excel",
    "Importer": "Importør",
    "Import clients from Excel": "Importer klienter fra Excel",
    "Account settings": "Bruger indstillinger",
    "Empty": "Tom",
};
export default translations